module.exports = {
	"images": {
		"bob01_diffuse.png": "data/hair/bob01/bob01_diffuse.png",
		"lit_asian.png": "data/litspheres/lit_asian.png",
		"reset.png": "data/themes/makehuman/icons/reset.png",
		"middleage_darkskinned_male_diffuse.png": "data/skins/textures/middleage_darkskinned_male_diffuse.png",
		"wireframe.png": "data/themes/makehuman/icons/wireframe.png",
		"l-hand-trans-in-out.png": "data/targets/armslegs/images/l-hand-trans-in-out.png",
		"l-foot-scale-decr-incr.png": "data/targets/armslegs/images/l-foot-scale-decr-incr.png",
		"l-foot-trans-down-up.png": "data/targets/armslegs/images/l-foot-trans-down-up.png",
		"r-ear-width-min-max.png": "data/targets/ears/images/r-ear-width-min-max.png",
		"shoes02_diffuse.png": "data/clothes/shoes02/shoes02_diffuse.png",
		"shoes05_diffuse.png": "data/clothes/shoes05/shoes05_diffuse.png",
		"short01_diffuse.png": "data/hair/short01/short01_diffuse.png",
		"l-cheek-inner-deflate-inflate.png": "data/targets/cheek/images/l-cheek-inner-deflate-inflate.png",
		"symm.png": "data/themes/makehuman/icons/symm.png",
		"head-back-scale-depth-less-more.png": "data/targets/head/images/head-back-scale-depth-less-more.png",
		"young_darkskinned_female_diffuse.png": "data/skins/textures/young_darkskinned_female_diffuse.png",
		"male_worksuit01_ao.png": "data/clothes/male_worksuit01/male_worksuit01_ao.png",
		"mouth-upperlip-height-min-max.png": "data/targets/mouth/images/mouth-upperlip-height-min-max.png",
		"torso-trans-depth-forward-backward.png": "data/targets/torso/images/torso-trans-depth-forward-backward.png",
		"female_elegantsuit01_ao.png": "data/clothes/female_elegantsuit01/female_elegantsuit01_ao.png",
		"resetcam.png": "data/themes/makehuman/icons/resetCam.png",
		"male_casualsuit04_normal.png": "data/clothes/male_casualsuit04/male_casualsuit04_normal.png",
		"r-eye-move-in-out.png": "data/targets/eyes/images/r-eye-move-in-out.png",
		"r-hand-fingers-length-decr-incr.png": "data/targets/armslegs/images/r-hand-fingers-length-decr-incr.png",
		"l-upperarm-muscle-decr-incr.png": "data/targets/armslegs/images/l-upperarm-muscle-decr-incr.png",
		"breast-volume-vert-up-down.png": "data/targets/breast/images/breast-volume-vert-up-down.png",
		"shoes01_normal.png": "data/clothes/shoes01/shoes01_normal.png",
		"fedora_normal.png": "data/clothes/fedora01/materials/fedora_normal.png",
		"nose-trans-horiz-in-out.png": "data/targets/nose/images/nose-trans-horiz-in-out.png",
		"l-eye-size-small-big.png": "data/targets/eyes/images/l-eye-size-small-big.png",
		"r-lowerleg-scale-horiz-decr-incr.png": "data/targets/armslegs/images/r-lowerleg-scale-horiz-decr-incr.png",
		"bluegreen_eye.png": "data/eyes/materials/bluegreen_eye.png",
		"l-eye-move-in-out.png": "data/targets/eyes/images/l-eye-move-in-out.png",
		"chin-prominent-less-more.png": "data/targets/chin/images/chin-prominent-less-more.png",
		"lit_refl_sharp_aniso_hard_blonde.png": "data/litspheres/lit_refl_sharp_aniso_hard_blonde.png",
		"mouth-philtrum-volume-increase-decrease.png": "data/targets/mouth/images/mouth-philtrum-volume-increase-decrease.png",
		"torso-vshape-less-more.png": "data/targets/torso/images/torso-vshape-less-more.png",
		"mouth-upperlip-middle-down-up.png": "data/targets/mouth/images/mouth-upperlip-middle-down-up.png",
		"eyebrow011.png": "data/eyebrows/eyebrow011/eyebrow011.png",
		"hip-waist-down-up.png": "data/targets/hip/images/hip-waist-down-up.png",
		"breast-point-min-max.png": "data/targets/breast/images/breast-point-min-max.png",
		"female_sportsuit01_ao.png": "data/clothes/female_sportsuit01/female_sportsuit01_ao.png",
		"down_arrow.png": "data/themes/makehuman/images/down_arrow.png",
		"green_eye.png": "data/eyes/materials/green_eye.png",
		"r-hand-scale-decr-incr.png": "data/targets/armslegs/images/r-hand-scale-decr-incr.png",
		"old_lightskinned_male_diffuse.png": "data/skins/textures/old_lightskinned_male_diffuse.png",
		"r-cheek-volume-deflate-inflate.png": "data/targets/cheek/images/r-cheek-volume-deflate-inflate.png",
		"legs-upperlegheight-decr-incr.png": "data/targets/legs/images/legs-upperlegheight-decr-incr.png",
		"breast-dist-min-max.png": "data/targets/breast/images/breast-dist-min-max.png",
		"head-oval.png": "data/targets/head/images/head-oval.png",
		"load.png": "data/themes/makehuman/icons/load.png",
		"r-foot-trans-in-out.png": "data/targets/armslegs/images/r-foot-trans-in-out.png",
		"head-skinny-fat.png": "data/targets/head/images/head-skinny-fat.png",
		"r-cheek-trans-vert-down-up.png": "data/targets/cheek/images/r-cheek-trans-vert-down-up.png",
		"l-lowerleg-scale-depth-decr-incr.png": "data/targets/armslegs/images/l-lowerleg-scale-depth-decr-incr.png",
		"l-eye-corner2-down-up.png": "data/targets/eyes/images/l-eye-corner2-down-up.png",
		"pose.png": "data/themes/makehuman/icons/pose.png",
		"female_casualsuit01_normal.png": "data/clothes/female_casualsuit01/female_casualsuit01_normal.png",
		"l-upperarm-scale-vert-decr-incr.png": "data/targets/armslegs/images/l-upperarm-scale-vert-decr-incr.png",
		"l-hand-fingers-diameter-decr-incr.png": "data/targets/armslegs/images/l-hand-fingers-diameter-decr-incr.png",
		"brown_eye.png": "data/eyes/materials/brown_eye.png",
		"eyebrow007.png": "data/eyebrows/eyebrow007/eyebrow007.png",
		"chin-height-min-max.png": "data/targets/chin/images/chin-height-min-max.png",
		"l-cheek-trans-vert-down-up.png": "data/targets/cheek/images/l-cheek-trans-vert-down-up.png",
		"male_casualsuit05_diffuse.png": "data/clothes/male_casualsuit05/male_casualsuit05_diffuse.png",
		"l-eye-push1-in-out.png": "data/targets/eyes/images/l-eye-push1-in-out.png",
		"symm1.png": "data/themes/makehuman/icons/symm1.png",
		"eyebrow012.png": "data/eyebrows/eyebrow012/eyebrow012.png",
		"male_casualsuit05_ao.png": "data/clothes/male_casualsuit05/male_casualsuit05_ao.png",
		"r-ear-wing-in-out.png": "data/targets/ears/images/r-ear-wing-in-out.png",
		"ponytail01_diffuse.png": "data/hair/ponytail01/ponytail01_diffuse.png",
		"buttocks-volume-decr-incr.png": "data/targets/buttocks/images/buttocks-volume-decr-incr.png",
		"male_worksuit01_normal.png": "data/clothes/male_worksuit01/male_worksuit01_normal.png",
		"l-eye-move-down-up.png": "data/targets/eyes/images/l-eye-move-down-up.png",
		"r-upperleg-skinny-fat.png": "data/targets/armslegs/images/r-upperleg-skinny-fat.png",
		"notfound.png": "data/icons/notfound.png",
		"fedora_texture_grey.png": "data/clothes/fedora01/materials/fedora_texture_grey.png",
		"nose-hump-lesshump-morehump.png": "data/targets/nose/images/nose-hump-lesshump-morehump.png",
		"r-lowerarm-skinny-fat.png": "data/targets/armslegs/images/r-lowerarm-skinny-fat.png",
		"breast-trans-vert-down-up.target.png": "data/targets/breast/images/breast-trans-vert-down-up.target.png",
		"l-lowerarm-scale-vert-decr-incr.png": "data/targets/armslegs/images/l-lowerarm-scale-vert-decr-incr.png",
		"l-cheek-volume-deflate-inflate.png": "data/targets/cheek/images/l-cheek-volume-deflate-inflate.png",
		"young_lightskinned_female_diffuse3.png": "data/skins/textures/young_lightskinned_female_diffuse3.png",
		"l-ear-trans-depth-backward-forward.png": "data/targets/ears/images/l-ear-trans-depth-backward-forward.png",
		"eyebrows-trans-vert-less-more.png": "data/targets/eyebrows/images/eyebrows-trans-vert-less-more.png",
		"bob02_diffuse.png": "data/hair/bob02/bob02_diffuse.png",
		"r-foot-scale-decr-incr.png": "data/targets/armslegs/images/r-foot-scale-decr-incr.png",
		"eyebrow004.png": "data/eyebrows/eyebrow004/eyebrow004.png",
		"head-scale-horiz-less-more.png": "data/targets/head/images/head-scale-horiz-less-more.png",
		"male_casualsuit06_ao.png": "data/clothes/male_casualsuit06/male_casualsuit06_ao.png",
		"r-ear-lobe-min-max.png": "data/targets/ears/images/r-ear-lobe-min-max.png",
		"penis-circ-min-max.png": "data/targets/genitals/images/penis-circ-min-max.png",
		"splash.png": "data/themes/default/images/splash.png",
		"young_lightskinned_male_diffuse3.png": "data/skins/textures/young_lightskinned_male_diffuse3.png",
		"head-scale-vert-less-more.png": "data/targets/head/images/head-scale-vert-less-more.png",
		"head-angle-in-out.png": "data/targets/head/images/head-angle-in-out.png",
		"l-lowerarm-skinny-fat.png": "data/targets/armslegs/images/l-lowerarm-skinny-fat.png",
		"head-trans-in-out.png": "data/targets/head/images/head-trans-in-out.png",
		"middleage_lightskinned_female_diffuse2.png": "data/skins/textures/middleage_lightskinned_female_diffuse2.png",
		"skinmat_african.png": "data/litspheres/skinmat_african.png",
		"breast-trans-vert-down-up.png": "data/targets/breast/images/breast-trans-vert-down-up.png",
		"young_caucasian_female_special_suit.png": "data/skins/textures/young_caucasian_female_special_suit.png",
		"male_casualsuit04_diffuse.png": "data/clothes/male_casualsuit04/male_casualsuit04_diffuse.png",
		"nose-width3-min-max.png": "data/targets/nose/images/nose-width3-min-max.png",
		"lit_leather.png": "data/litspheres/lit_leather.png",
		"head-rectangular.png": "data/targets/head/images/head-rectangular.png",
		"lit_african_sweat.png": "data/litspheres/lit_african_sweat.png",
		"lit_hair.png": "data/litspheres/lit_hair.png",
		"head-age-less-more.png": "data/targets/head/images/head-age-less-more.png",
		"r-foot-scale-horiz-decr-incr.png": "data/targets/armslegs/images/r-foot-scale-horiz-decr-incr.png",
		"r-eye-corner2-down-up.png": "data/targets/eyes/images/r-eye-corner2-down-up.png",
		"torso-scale-depth-decr-incr.png": "data/targets/torso/images/torso-scale-depth-decr-incr.png",
		"lit_refl_sharp_aniso_hard.png": "data/litspheres/lit_refl_sharp_aniso_hard.png",
		"head-square.png": "data/targets/head/images/head-square.png",
		"r-lowerarm-scale-vert-decr-incr.png": "data/targets/armslegs/images/r-lowerarm-scale-vert-decr-incr.png",
		"mouth-scale-horiz-decr-incr.png": "data/targets/mouth/images/mouth-scale-horiz-decr-incr.png",
		"eyebrow002.png": "data/eyebrows/eyebrow002/eyebrow002.png",
		"r-ear-flap-in-out.png": "data/targets/ears/images/r-ear-flap-in-out.png",
		"male_casualsuit04_ao.png": "data/clothes/male_casualsuit04/male_casualsuit04_ao.png",
		"r-upperarm-scale-depth-decr-incr.png": "data/targets/armslegs/images/r-upperarm-scale-depth-decr-incr.png",
		"lit_toon01.png": "data/litspheres/lit_toon01.png",
		"neck-scale-vert-less-more.png": "data/targets/neck/images/neck-scale-vert-less-more.png",
		"short02_normal.png": "data/hair/short02/short02_normal.png",
		"skinmat_eye.png": "data/litspheres/skinmat_eye.png",
		"texture_notfound.png": "data/textures/texture_notfound.png",
		"hip-scale-horiz-decr-incr.png": "data/targets/hip/images/hip-scale-horiz-decr-incr.png",
		"middleage_darkskinned_female_diffuse.png": "data/skins/textures/middleage_darkskinned_female_diffuse.png",
		"l-upperarm-shoulder-muscle-decr-incr.png": "data/targets/armslegs/images/l-upperarm-shoulder-muscle-decr-incr.png",
		"r-eye-height1-min-max.png": "data/targets/eyes/images/r-eye-height1-min-max.png",
		"r-lowerarm-muscle-decr-incr.png": "data/targets/armslegs/images/r-lowerarm-muscle-decr-incr.png",
		"grid.png": "data/themes/makehuman/icons/grid.png",
		"branch-open.png": "data/themes/makehuman/images/branch-open.png",
		"male_casualsuit02_ao.png": "data/clothes/male_casualsuit02/male_casualsuit02_ao.png",
		"l-lowerleg-scale-vert-decr-incr.png": "data/targets/armslegs/images/l-lowerleg-scale-vert-decr-incr.png",
		"female_casualsuit01_ao.png": "data/clothes/female_casualsuit01/female_casualsuit01_ao.png",
		"short02_diffuse.png": "data/hair/short02/short02_diffuse.png",
		"shoes04_diffuse.png": "data/clothes/shoes04/shoes04_diffuse.png",
		"forehead-scale-vert-less-more.png": "data/targets/forehead/images/forehead-scale-vert-less-more.png",
		"lit_caucasian_sweat.png": "data/litspheres/lit_caucasian_sweat.png",
		"eyelashes02.png": "data/eyelashes/eyelashes02/eyelashes02.png",
		"nose-width2-min-max.png": "data/targets/nose/images/nose-width2-min-max.png",
		"r-eye-move-down-up.png": "data/targets/eyes/images/r-eye-move-down-up.png",
		"hip-trans-down-up.png": "data/targets/hip/images/hip-trans-down-up.png",
		"male_casualsuit02_diffuse.png": "data/clothes/male_casualsuit02/male_casualsuit02_diffuse.png",
		"lit_refl_sharp_aniso.png": "data/litspheres/lit_refl_sharp_aniso.png",
		"head-trans-backward-forward.png": "data/targets/head/images/head-trans-backward-forward.png",
		"r-upperarm-muscle-decr-incr.png": "data/targets/armslegs/images/r-upperarm-muscle-decr-incr.png",
		"branch-closed.png": "data/themes/makehuman/images/branch-closed.png",
		"l-upperleg-scale-horiz-decr-incr.png": "data/targets/armslegs/images/l-upperleg-scale-horiz-decr-incr.png",
		"l-eye-height1-min-max.png": "data/targets/eyes/images/l-eye-height1-min-max.png",
		"grey_eye.png": "data/eyes/materials/grey_eye.png",
		"r-cheek-bones-in-out.png": "data/targets/cheek/images/r-cheek-bones-in-out.png",
		"help.png": "data/themes/makehuman/icons/help.png",
		"stereo2.png": "data/themes/makehuman/icons/stereo2.png",
		"torso-scale-horiz-decr-incr.png": "data/targets/torso/images/torso-scale-horiz-decr-incr.png",
		"r-upperleg-muscle-decr-incr.png": "data/targets/armslegs/images/r-upperleg-muscle-decr-incr.png",
		"symm2.png": "data/themes/makehuman/icons/symm2.png",
		"mouth-scale-vert-decr-incr.png": "data/targets/mouth/images/mouth-scale-vert-decr-incr.png",
		"r-ear-size-small-big.png": "data/targets/ears/images/r-ear-size-small-big.png",
		"mouth-cupidsbow-decr-incr.png": "data/targets/mouth/images/mouth-cupidsbow-decr-incr.png",
		"l-ear-rot-backward-forward.png": "data/targets/ears/images/l-ear-rot-backward-forward.png",
		"l-ear-shape2-square-round.png": "data/targets/ears/images/l-ear-shape2-square-round.png",
		"female_casualsuit01_diffuse.png": "data/clothes/female_casualsuit01/female_casualsuit01_diffuse.png",
		"eyebrows-trans-depth-less-more.png": "data/targets/eyebrows/images/eyebrows-trans-depth-less-more.png",
		"nose-trans-vert-down-up.png": "data/targets/nose/images/nose-trans-vert-down-up.png",
		"nose-greek-lessgreek-moregreek.png": "data/targets/nose/images/nose-greek-lessgreek-moregreek.png",
		"fedora_displacement.png": "data/clothes/fedora01/materials/fedora_displacement.png",
		"female_sportsuit01_diffuse.png": "data/clothes/female_sportsuit01/female_sportsuit01_diffuse.png",
		"r-eye-size-small-big.png": "data/targets/eyes/images/r-eye-size-small-big.png",
		"r-ear-shape2-square-round.png": "data/targets/ears/images/r-ear-shape2-square-round.png",
		"r-foot-trans-down-up.png": "data/targets/armslegs/images/r-foot-trans-down-up.png",
		"chin-bones-in-out.png": "data/targets/chin/images/chin-bones-in-out.png",
		"stomach-pregnant-decr-incr.png": "data/targets/stomach/images/stomach-pregnant-decr-incr.png",
		"head-invertedtriangular.png": "data/targets/head/images/head-invertedtriangular.png",
		"mouth-upperlip-width-min-max.png": "data/targets/mouth/images/mouth-upperlip-width-min-max.png",
		"mono.png": "data/themes/makehuman/icons/mono.png",
		"eyebrow001.png": "data/eyebrows/eyebrow001/eyebrow001.png",
		"r-eye-height2-min-max.png": "data/targets/eyes/images/r-eye-height2-min-max.png",
		"eyelashes03.png": "data/eyelashes/eyelashes03/eyelashes03.png",
		"male_casualsuit03_ao.png": "data/clothes/male_casualsuit03/male_casualsuit03_ao.png",
		"lit_asian_sweat.png": "data/litspheres/lit_asian_sweat.png",
		"head-trans-down-up.png": "data/targets/head/images/head-trans-down-up.png",
		"r-foot-scale-vert-decr-incr.png": "data/targets/armslegs/images/r-foot-scale-vert-decr-incr.png",
		"lit_african.png": "data/litspheres/lit_african.png",
		"young_lightskinned_female_diffuse.png": "data/skins/textures/young_lightskinned_female_diffuse.png",
		"l-eye-height2-min-max.png": "data/targets/eyes/images/l-eye-height2-min-max.png",
		"neck-scale-depth-less-more.png": "data/targets/neck/images/neck-scale-depth-less-more.png",
		"eyelashes01.png": "data/eyelashes/eyelashes01/eyelashes01.png",
		"legs-lowerlegheight-decr-incr.png": "data/targets/legs/images/legs-lowerlegheight-decr-incr.png",
		"r-ear-trans-depth-backward-forward.png": "data/targets/ears/images/r-ear-trans-depth-backward-forward.png",
		"neck-trans-vert-down-up.png": "data/targets/neck/images/neck-trans-vert-down-up.png",
		"shoes01_diffuse.png": "data/clothes/shoes01/shoes01_diffuse.png",
		"male_casualsuit03_normal.png": "data/clothes/male_casualsuit03/male_casualsuit03_normal.png",
		"nose-scale-horiz-decr-incr.png": "data/targets/nose/images/nose-scale-horiz-decr-incr.png",
		"nose-scale-depth-decr-incr.png": "data/targets/nose/images/nose-scale-depth-decr-incr.png",
		"l-foot-scale-vert-decr-incr.png": "data/targets/armslegs/images/l-foot-scale-vert-decr-incr.png",
		"front.png": "data/themes/makehuman/icons/front.png",
		"young_darkskinned_male_diffuse.png": "data/skins/textures/young_darkskinned_male_diffuse.png",
		"l-upperarm-skinny-fat.png": "data/targets/armslegs/images/l-upperarm-skinny-fat.png",
		"long01_diffuse.png": "data/hair/long01/long01_diffuse.png",
		"l-lowerarm-scale-horiz-decr-incr.png": "data/targets/armslegs/images/l-lowerarm-scale-horiz-decr-incr.png",
		"r-foot-trans-forward-backward.png": "data/targets/armslegs/images/r-foot-trans-forward-backward.png",
		"torso-trans-vert-down-up.png": "data/targets/torso/images/torso-trans-vert-down-up.png",
		"forehead-trans-depth-forward-backward.png": "data/targets/forehead/images/forehead-trans-depth-forward-backward.png",
		"checkbox-orange.png": "data/themes/makehuman/images/checkbox-orange.png",
		"r-lowerleg-skinny-fat.png": "data/targets/armslegs/images/r-lowerleg-skinny-fat.png",
		"pelvis-tone-decr-incr.png": "data/targets/pelvis/images/pelvis-tone-decr-incr.png",
		"tongue01_diffuse.png": "data/tongue/tongue01/tongue01_diffuse.png",
		"l-upperarm-scale-horiz-decr-incr.png": "data/targets/armslegs/images/l-upperarm-scale-horiz-decr-incr.png",
		"eyebrows-angle-up-down.png": "data/targets/eyebrows/images/eyebrows-angle-up-down.png",
		"undo.png": "data/themes/makehuman/icons/undo.png",
		"r-lowerleg-scale-depth-decr-incr.png": "data/targets/armslegs/images/r-lowerleg-scale-depth-decr-incr.png",
		"old_lightskinned_female_diffuse2.png": "data/skins/textures/old_lightskinned_female_diffuse2.png",
		"l-upperleg-scale-vert-decr-incr.png": "data/targets/armslegs/images/l-upperleg-scale-vert-decr-incr.png",
		"chin-prognathism-less-more.png": "data/targets/chin/images/chin-prognathism-less-more.png",
		"eyebrow010.png": "data/eyebrows/eyebrow010/eyebrow010.png",
		"l-upperleg-skinny-fat.png": "data/targets/armslegs/images/l-upperleg-skinny-fat.png",
		"shoes04_normal.png": "data/clothes/shoes04/shoes04_normal.png",
		"mouth-lowerlip-volume-deflate-inflate.png": "data/targets/mouth/images/mouth-lowerlip-volume-deflate-inflate.png",
		"checkbox.png": "data/themes/makehuman/images/checkbox.png",
		"r-upperarm-skinny-fat.png": "data/targets/armslegs/images/r-upperarm-skinny-fat.png",
		"neck-back-scale-depth-less-more.png": "data/targets/neck/images/neck-back-scale-depth-less-more.png",
		"r-upperleg-scale-depth-decr-incr.png": "data/targets/armslegs/images/r-upperleg-scale-depth-decr-incr.png",
		"neck-scale-horiz-less-more.png": "data/targets/neck/images/neck-scale-horiz-less-more.png",
		"penis01_default.png": "data/genitals/penis01/penis01_default.png",
		"l-hand-scale-decr-incr.png": "data/targets/armslegs/images/l-hand-scale-decr-incr.png",
		"l-ear-flap-in-out.png": "data/targets/ears/images/l-ear-flap-in-out.png",
		"middleage_lightskinned_female_diffuse.png": "data/skins/textures/middleage_lightskinned_female_diffuse.png",
		"nose-flaring-decr-incr.png": "data/targets/nose/images/nose-flaring-decr-incr.png",
		"background.png": "data/themes/makehuman/icons/background.png",
		"r-foot-scale-depth-decr-incr.png": "data/targets/armslegs/images/r-foot-scale-depth-decr-incr.png",
		"l-foot-trans-forward-backward.png": "data/targets/armslegs/images/l-foot-trans-forward-backward.png",
		"torso-scale-vert-decr-incr.png": "data/targets/torso/images/torso-scale-vert-decr-incr.png",
		"shoes03_diffuse.png": "data/clothes/shoes03/shoes03_diffuse.png",
		"nose-point-down-up.png": "data/targets/nose/images/nose-point-down-up.png",
		"mouth-upperlip-volume-deflate-inflate.png": "data/targets/mouth/images/mouth-upperlip-volume-deflate-inflate.png",
		"bulge-decr-incr.png": "data/targets/pelvis/images/bulge-decr-incr.png",
		"lit_standard_skin.png": "data/litspheres/lit_standard_skin.png",
		"old_lightskinned_male_diffuse2.png": "data/skins/textures/old_lightskinned_male_diffuse2.png",
		"mouth-upperlip-ext-down-up.png": "data/targets/mouth/images/mouth-upperlip-ext-down-up.png",
		"female_elegantsuit01_normal.png": "data/clothes/female_elegantsuit01/female_elegantsuit01_normal.png",
		"mouth-lowerlip-width-min-max.png": "data/targets/mouth/images/mouth-lowerlip-width-min-max.png",
		"l-lowerleg-muscle-decr-incr.png": "data/targets/armslegs/images/l-lowerleg-muscle-decr-incr.png",
		"mouth-lowerlip-ext-up-down.png": "data/targets/mouth/images/mouth-lowerlip-ext-up-down.png",
		"female_casualsuit02_normal.png": "data/clothes/female_casualsuit02/female_casualsuit02_normal.png",
		"r-lowerarm-scale-horiz-decr-incr.png": "data/targets/armslegs/images/r-lowerarm-scale-horiz-decr-incr.png",
		"nose-height-min-max.png": "data/targets/nose/images/nose-height-min-max.png",
		"mouth-angles-down-up.png": "data/targets/mouth/images/mouth-angles-down-up.png",
		"r-lowerleg-scale-vert-decr-incr.png": "data/targets/armslegs/images/r-lowerleg-scale-vert-decr-incr.png",
		"l-eye-height3-min-max.png": "data/targets/eyes/images/l-eye-height3-min-max.png",
		"young_lightskinned_female_diffuse2.png": "data/skins/textures/young_lightskinned_female_diffuse2.png",
		"r-lowerarm-scale-depth-decr-incr.png": "data/targets/armslegs/images/r-lowerarm-scale-depth-decr-incr.png",
		"eyebrow009.png": "data/eyebrows/eyebrow009/eyebrow009.png",
		"r-ear-trans-vert-down-up.png": "data/targets/ears/images/r-ear-trans-vert-down-up.png",
		"middleage_lightskinned_male_diffuse.png": "data/skins/textures/middleage_lightskinned_male_diffuse.png",
		"male_casualsuit06_diffuse.png": "data/clothes/male_casualsuit06/male_casualsuit06_diffuse.png",
		"female_sportsuit01_normal.png": "data/clothes/female_sportsuit01/female_sportsuit01_normal.png",
		"nose-trans-depth-backward-forward.png": "data/targets/nose/images/nose-trans-depth-backward-forward.png",
		"nose-volume-potato-point.png": "data/targets/nose/images/nose-volume-potato-point.png",
		"lightblue_eye.png": "data/eyes/materials/lightblue_eye.png",
		"bottom.png": "data/themes/makehuman/icons/bottom.png",
		"old_darkskinned_female_diffuse.png": "data/skins/textures/old_darkskinned_female_diffuse.png",
		"skinmat_caucasian.png": "data/litspheres/skinmat_caucasian.png",
		"mouth-trans-in-out.png": "data/targets/mouth/images/mouth-trans-in-out.png",
		"brownlight_eye.png": "data/eyes/materials/brownlight_eye.png",
		"forehead-temple-in-out.png": "data/targets/forehead/images/forehead-temple-in-out.png",
		"l-foot-trans-in-out.png": "data/targets/armslegs/images/l-foot-trans-in-out.png",
		"male_casualsuit02_normal.png": "data/clothes/male_casualsuit02/male_casualsuit02_normal.png",
		"young_lightskinned_male_diffuse.png": "data/skins/textures/young_lightskinned_male_diffuse.png",
		"r-ear-shape1-pointed-triangle.png": "data/targets/ears/images/r-ear-shape1-pointed-triangle.png",
		"fedora_texture_black.png": "data/clothes/fedora01/materials/fedora_texture_black.png",
		"r-upperarm-scale-horiz-decr-incr.png": "data/targets/armslegs/images/r-upperarm-scale-horiz-decr-incr.png",
		"hip-trans-forward-backward.png": "data/targets/hip/images/hip-trans-forward-backward.png",
		"forehead-nubian-less-more.png": "data/targets/forehead/images/forehead-nubian-less-more.png",
		"r-eye-push2-out-in.png": "data/targets/eyes/images/r-eye-push2-out-in.png",
		"l-ear-width-min-max.png": "data/targets/ears/images/l-ear-width-min-max.png",
		"l-lowerleg-scale-horiz-decr-incr.png": "data/targets/armslegs/images/l-lowerleg-scale-horiz-decr-incr.png",
		"mouth-scale-depth-decr-incr.png": "data/targets/mouth/images/mouth-scale-depth-decr-incr.png",
		"lit_refl_sharp.png": "data/litspheres/lit_refl_sharp.png",
		"l-upperarm-scale-depth-decr-incr.png": "data/targets/armslegs/images/l-upperarm-scale-depth-decr-incr.png",
		"head-diamond.png": "data/targets/head/images/head-diamond.png",
		"young_lightskinned_male_diffuse2.png": "data/skins/textures/young_lightskinned_male_diffuse2.png",
		"neck-trans-horiz-in-out.png": "data/targets/neck/images/neck-trans-horiz-in-out.png",
		"l-eye-push2-out-in.png": "data/targets/eyes/images/l-eye-push2-out-in.png",
		"hip-trans-in-out.png": "data/targets/hip/images/hip-trans-in-out.png",
		"eyebrow005.png": "data/eyebrows/eyebrow005/eyebrow005.png",
		"nose-compression-compress-uncompress.png": "data/targets/nose/images/nose-compression-compress-uncompress.png",
		"r-cheek-inner-deflate-inflate.png": "data/targets/cheek/images/r-cheek-inner-deflate-inflate.png",
		"mouth-trans-backward-forward.png": "data/targets/mouth/images/mouth-trans-backward-forward.png",
		"hip-scale-depth-decr-incr.png": "data/targets/hip/images/hip-scale-depth-decr-incr.png",
		"stomach-tone-decr-incr.png": "data/targets/stomach/images/stomach-tone-decr-incr.png",
		"old_lightskinned_female_diffuse.png": "data/skins/textures/old_lightskinned_female_diffuse.png",
		"nose-scale-vert-decr-incr.png": "data/targets/nose/images/nose-scale-vert-decr-incr.png",
		"l-eye-corner1-down-up.png": "data/targets/eyes/images/l-eye-corner1-down-up.png",
		"neck-trans-depth-forward-backward.png": "data/targets/neck/images/neck-trans-depth-forward-backward.png",
		"old_darkskinned_male_diffuse.png": "data/skins/textures/old_darkskinned_male_diffuse.png",
		"fedora_texture.png": "data/clothes/fedora01/materials/fedora_texture.png",
		"left.png": "data/themes/makehuman/icons/left.png",
		"torso-muscle-dorsi-decr-incr.png": "data/targets/torso/images/torso-muscle-dorsi-decr-incr.png",
		"l-foot-scale-horiz-decr-incr.png": "data/targets/armslegs/images/l-foot-scale-horiz-decr-incr.png",
		"l-lowerarm-muscle-decr-incr.png": "data/targets/armslegs/images/l-lowerarm-muscle-decr-incr.png",
		"breastfirmness.png": "data/targets/breast/images/breastfirmness.png",
		"l-upperleg-muscle-decr-incr.png": "data/targets/armslegs/images/l-upperleg-muscle-decr-incr.png",
		"skinmat_asian.png": "data/litspheres/skinmat_asian.png",
		"hip-scale-vert-decr-incr.png": "data/targets/hip/images/hip-scale-vert-decr-incr.png",
		"eyelashes04.png": "data/eyelashes/eyelashes04/eyelashes04.png",
		"mouth-lowerlip-height-min-max.png": "data/targets/mouth/images/mouth-lowerlip-height-min-max.png",
		"afro_diffuse.png": "data/hair/afro01/afro_diffuse.png",
		"deepblue_eye.png": "data/eyes/materials/deepblue_eye.png",
		"l-ear-lobe-min-max.png": "data/targets/ears/images/l-ear-lobe-min-max.png",
		"l-ear-trans-vert-down-up.png": "data/targets/ears/images/l-ear-trans-vert-down-up.png",
		"r-ear-height-min-max.png": "data/targets/ears/images/r-ear-height-min-max.png",
		"short03_diffuse.png": "data/hair/short03/short03_diffuse.png",
		"breastsize.png": "data/targets/breast/images/breastsize.png",
		"export.png": "data/themes/makehuman/icons/export.png",
		"female_elegantsuit01_diffuse.png": "data/clothes/female_elegantsuit01/female_elegantsuit01_diffuse.png",
		"male_casualsuit03_diffuse.png": "data/clothes/male_casualsuit03/male_casualsuit03_diffuse.png",
		"r-eye-push1-in-out.png": "data/targets/eyes/images/r-eye-push1-in-out.png",
		"head-scale-depth-less-more.png": "data/targets/head/images/head-scale-depth-less-more.png",
		"redo.png": "data/themes/makehuman/icons/redo.png",
		"l-hand-fingers-length-decr-incr.png": "data/targets/armslegs/images/l-hand-fingers-length-decr-incr.png",
		"nose-nostril-width-min-max.png": "data/targets/nose/images/nose-nostril-width-min-max.png",
		"top.png": "data/themes/makehuman/icons/top.png",
		"female_casualsuit02_diffuse.png": "data/clothes/female_casualsuit02/female_casualsuit02_diffuse.png",
		"l-ear-size-small-big.png": "data/targets/ears/images/l-ear-size-small-big.png",
		"r-eye-height3-min-max.png": "data/targets/eyes/images/r-eye-height3-min-max.png",
		"male_worksuit01_diffuse.png": "data/clothes/male_worksuit01/male_worksuit01_diffuse.png",
		"r-upperarm-scale-vert-decr-incr.png": "data/targets/armslegs/images/r-upperarm-scale-vert-decr-incr.png",
		"nose-nostrils-angle-down-up.png": "data/targets/nose/images/nose-nostrils-angle-down-up.png",
		"head-round.png": "data/targets/head/images/head-round.png",
		"blue_eye.png": "data/eyes/materials/blue_eye.png",
		"nose-septumangle-decr-incr.png": "data/targets/nose/images/nose-septumangle-decr-incr.png",
		"l-upperleg-scale-depth-decr-incr.png": "data/targets/armslegs/images/l-upperleg-scale-depth-decr-incr.png",
		"l-cheek-bones-in-out.png": "data/targets/cheek/images/l-cheek-bones-in-out.png",
		"r-leg-genu-varun-valgus.png": "data/targets/armslegs/images/r-leg-genu-varun-valgus.png",
		"female_casualsuit02_ao.png": "data/clothes/female_casualsuit02/female_casualsuit02_ao.png",
		"short04_diffuse.png": "data/hair/short04/short04_diffuse.png",
		"torso-muscle-pectoral-decr-incr.png": "data/targets/torso/images/torso-muscle-pectoral-decr-incr.png",
		"male_casualsuit05_normal.png": "data/clothes/male_casualsuit05/male_casualsuit05_normal.png",
		"male_casualsuit01_normal.png": "data/clothes/male_casualsuit01/male_casualsuit01_normal.png",
		"l-ear-height-min-max.png": "data/targets/ears/images/l-ear-height-min-max.png",
		"eyebrow006.png": "data/eyebrows/eyebrow006/eyebrow006.png",
		"mouth-lowerlip-middle-up-down.png": "data/targets/mouth/images/mouth-lowerlip-middle-up-down.png",
		"ice_eye.png": "data/eyes/materials/ice_eye.png",
		"nose-point-width-less-more.png": "data/targets/nose/images/nose-point-width-less-more.png",
		"eyebrow003.png": "data/eyebrows/eyebrow003/eyebrow003.png",
		"savetgt.png": "data/themes/makehuman/icons/savetgt.png",
		"grab.png": "data/themes/makehuman/icons/grab.png",
		"r-eye-corner1-down-up.png": "data/targets/eyes/images/r-eye-corner1-down-up.png",
		"lit_matte.png": "data/litspheres/lit_matte.png",
		"torso-trans-horiz-in-out.png": "data/targets/torso/images/torso-trans-horiz-in-out.png",
		"male_casualsuit01_diffuse.png": "data/clothes/male_casualsuit01/male_casualsuit01_diffuse.png",
		"r-upperarm-shoulder-muscle-decr-incr.png": "data/targets/armslegs/images/r-upperarm-shoulder-muscle-decr-incr.png",
		"braid01_diffuse.png": "data/hair/braid01/braid01_diffuse.png",
		"nose-curve-concave-convex.png": "data/targets/nose/images/nose-curve-concave-convex.png",
		"l-foot-scale-depth-decr-incr.png": "data/targets/armslegs/images/l-foot-scale-depth-decr-incr.png",
		"lit_caucasian.png": "data/litspheres/lit_caucasian.png",
		"smooth.png": "data/themes/makehuman/icons/smooth.png",
		"stomach-navel-down-up.png": "data/targets/stomach/images/stomach-navel-down-up.png",
		"save.png": "data/themes/makehuman/icons/save.png",
		"l-lowerarm-scale-depth-decr-incr.png": "data/targets/armslegs/images/l-lowerarm-scale-depth-decr-incr.png",
		"r-lowerleg-muscle-decr-incr.png": "data/targets/armslegs/images/r-lowerleg-muscle-decr-incr.png",
		"l-ear-wing-in-out.png": "data/targets/ears/images/l-ear-wing-in-out.png",
		"back.png": "data/themes/makehuman/icons/back.png",
		"right.png": "data/themes/makehuman/icons/right.png",
		"shoes06_diffuse.png": "data/clothes/shoes06/shoes06_diffuse.png",
		"r-hand-fingers-diameter-decr-incr.png": "data/targets/armslegs/images/r-hand-fingers-diameter-decr-incr.png",
		"r-ear-rot-backward-forward.png": "data/targets/ears/images/r-ear-rot-backward-forward.png",
		"mouth-cupidsbow-width-min-max.png": "data/targets/mouth/images/mouth-cupidsbow-width-min-max.png",
		"teeth.png": "data/teeth/materials/teeth.png",
		"l-ear-shape1-pointed-triangle.png": "data/targets/ears/images/l-ear-shape1-pointed-triangle.png",
		"penis-length-min-max.png": "data/targets/genitals/images/penis-length-min-max.png",
		"r-hand-trans-in-out.png": "data/targets/armslegs/images/r-hand-trans-in-out.png",
		"mouth-up-down.png": "data/targets/mouth/images/mouth-up-down.png",
		"male_casualsuit01_ao.png": "data/clothes/male_casualsuit01/male_casualsuit01_ao.png",
		"r-upperleg-scale-horiz-decr-incr.png": "data/targets/armslegs/images/r-upperleg-scale-horiz-decr-incr.png",
		"r-upperleg-scale-vert-decr-incr.png": "data/targets/armslegs/images/r-upperleg-scale-vert-decr-incr.png",
		"mouth-trans-down-up.png": "data/targets/mouth/images/mouth-trans-down-up.png",
		"eyebrow008.png": "data/eyebrows/eyebrow008/eyebrow008.png",
		"handle.png": "data/themes/makehuman/images/handle.png",
		"stereo1.png": "data/themes/makehuman/icons/stereo1.png",
		"chin-width-min-max.png": "data/targets/chin/images/chin-width-min-max.png",
		"l-leg-genu-varun-valgus.png": "data/targets/armslegs/images/l-leg-genu-varun-valgus.png",
		"young_caucasian_male_special_suit.png": "data/skins/textures/young_caucasian_male_special_suit.png",
		"nose-width1-min-max.png": "data/targets/nose/images/nose-width1-min-max.png",
		"l-lowerleg-skinny-fat.png": "data/targets/armslegs/images/l-lowerleg-skinny-fat.png",
		"male_elegantsuit01_diffuse.png": "data/clothes/male_elegantsuit01/male_elegantsuit01_diffuse.png",
		"penis-testicles-min-max.png": "data/targets/genitals/images/penis-testicles-min-max.png",
		"middleage_lightskinned_male_diffuse2.png": "data/skins/textures/middleage_lightskinned_male_diffuse2.png",
		"head-triangular.png": "data/targets/head/images/head-triangular.png",
		"male_casualsuit06_normal.png": "data/clothes/male_casualsuit06/male_casualsuit06_normal.png",
		"qexport.png": "data/themes/makehuman/icons/qexport.png"
	},
	"targets": {
		"data/targets/expression/units/african/nose-compression.target": [
			"expression",
			"units",
			"nose",
			"compression"
		],
		"data/targets/chin/chin-triangle.target": [
			"chin",
			"chin",
			"triangle"
		],
		"data/targets/macrodetails/african-female-young.target": [
			"macrodetails"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/ears/l-ear-trans-depth-forward.target": [
			"ears",
			"l",
			"ear",
			"trans",
			"depth",
			"forward"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-move-out.target": [
			"eyes",
			"l",
			"eye",
			"move",
			"out"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/nose-left-dilatation.target": [
			"expression",
			"units",
			"nose",
			"left",
			"dilatation"
		],
		"data/targets/macrodetails/height/male-child-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/african/eyebrows-right-down.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"down"
		],
		"data/targets/breast/nipple-point-in.target": [
			"breast",
			"nipple",
			"point",
			"in"
		],
		"data/targets/eyes/l-eye-push1-in.target": [
			"eyes",
			"l",
			"eye",
			"push1",
			"in"
		],
		"data/targets/ears/l-ear-lobe-min.target": [
			"ears",
			"l",
			"ear",
			"lobe",
			"min"
		],
		"data/targets/macrodetails/universal-female-young-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-male-baby-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/mouth/mouth-cupidsbow-width-max.target": [
			"mouth",
			"mouth",
			"cupidsbow",
			"width",
			"max"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/nose/nose-scale-depth-decr.target": [
			"nose",
			"nose",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/eyebrows-right-inner-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"inner",
			"up"
		],
		"data/targets/neck/neck-scale-horiz-less.target": [
			"neck",
			"neck",
			"scale",
			"horiz",
			"less"
		],
		"data/targets/nose/nose-hump-morehump.target": [
			"nose",
			"nose",
			"hump",
			"morehump"
		],
		"data/targets/expression/units/asian/eye-right-closure.target": [
			"expression",
			"units",
			"eye",
			"right",
			"closure"
		],
		"data/targets/macrodetails/asian-female-child.target": [
			"macrodetails"
		],
		"data/targets/eyes/l-eye-push2-out.target": [
			"eyes",
			"l",
			"eye",
			"push2",
			"out"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/mouth/mouth-trans-in.target": [
			"mouth",
			"mouth",
			"trans",
			"in"
		],
		"data/targets/eyes/r-eye-push2-in.target": [
			"eyes",
			"r",
			"eye",
			"push2",
			"in"
		],
		"data/targets/macrodetails/universal-female-baby-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/male-old-minmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/eyes/l-eye-move-up.target": [
			"eyes",
			"l",
			"eye",
			"move",
			"up"
		],
		"data/targets/armslegs/l-foot-scale-vert-decr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/armslegs/r-upperarm-scale-depth-incr.target": [
			"armslegs",
			"r",
			"upperarm",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-upperleg-scale-horiz-decr.target": [
			"armslegs",
			"l",
			"upperleg",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/expression/units/african/eyebrows-left-down.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"down"
		],
		"data/targets/nose/nose-height-min.target": [
			"nose",
			"nose",
			"height",
			"min"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/ears/l-ear-shape1-pointed.target": [
			"ears",
			"l",
			"ear",
			"shape1",
			"pointed"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/nose-compression.target": [
			"expression",
			"units",
			"nose",
			"compression"
		],
		"data/targets/macrodetails/universal-female-young-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/eyes/r-eye-height3-min.target": [
			"eyes",
			"r",
			"eye",
			"height3",
			"min"
		],
		"data/targets/cheek/r-cheek-bones-in.target": [
			"cheek",
			"r",
			"cheek",
			"bones",
			"in"
		],
		"data/targets/armslegs/r-hand-scale-incr.target": [
			"armslegs",
			"r",
			"hand",
			"scale",
			"incr"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/torso/torso-trans-horiz-out.target": [
			"torso",
			"torso",
			"trans",
			"horiz",
			"out"
		],
		"data/targets/macrodetails/height/female-child-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-brown-1-r.target": [
			"asym",
			"asym",
			"brown",
			"1",
			"r"
		],
		"data/targets/asym/asym-nose-4-l.target": [
			"asym",
			"asym",
			"nose",
			"4",
			"l"
		],
		"data/targets/armslegs/r-upperarm-scale-depth-decr.target": [
			"armslegs",
			"r",
			"upperarm",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/eyes/r-eye-corner1-down.target": [
			"eyes",
			"r",
			"eye",
			"corner1",
			"down"
		],
		"data/targets/macrodetails/height/female-old-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-male-young-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/african-female-child.target": [
			"macrodetails"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/ears/r-ear-size-small.target": [
			"ears",
			"r",
			"ear",
			"size",
			"small"
		],
		"data/targets/macrodetails/proportions/male-child-averagemuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/male-child-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/eyes/r-eye-bag-height-max.target": [
			"eyes",
			"r",
			"eye",
			"bag",
			"height",
			"max"
		],
		"data/targets/armslegs/l-hand-fingers-length-decr.target": [
			"armslegs",
			"l",
			"hand",
			"fingers",
			"length",
			"decr"
		],
		"data/targets/macrodetails/height/male-old-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-maxmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/pelvis/bulge-decr.target": [
			"pelvis",
			"bulge",
			"decr"
		],
		"data/targets/neck/neck-trans-vert-down.target": [
			"neck",
			"neck",
			"trans",
			"vert",
			"down"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-old-maxmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/african/eyebrows-left-extern-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"extern",
			"up"
		],
		"data/targets/pelvis/pelvis-tone-incr.target": [
			"pelvis",
			"pelvis",
			"tone",
			"incr"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-upperarm-scale-depth-decr.target": [
			"armslegs",
			"l",
			"upperarm",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/armslegs/l-foot-scale-horiz-decr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/macrodetails/proportions/male-old-minmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asym-mouth-2-l.target": [
			"asym",
			"asym",
			"mouth",
			"2",
			"l"
		],
		"data/targets/eyes/r-eye-size-small.target": [
			"eyes",
			"r",
			"eye",
			"size",
			"small"
		],
		"data/targets/macrodetails/height/male-young-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/caucasian/nose-right-dilatation.target": [
			"expression",
			"units",
			"nose",
			"right",
			"dilatation"
		],
		"data/targets/eyes/l-eye-corner1-up.target": [
			"eyes",
			"l",
			"eye",
			"corner1",
			"up"
		],
		"data/targets/measure/measure-lowerarmlenght-increase.target": [
			"measure",
			"measure",
			"lowerarmlenght",
			"increase"
		],
		"data/targets/macrodetails/height/male-old-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/eyes/l-eye-bag-height-min.target": [
			"eyes",
			"l",
			"eye",
			"bag",
			"height",
			"min"
		],
		"data/targets/buttocks/buttocks-volume-decr.target": [
			"buttocks",
			"buttocks",
			"volume",
			"decr"
		],
		"data/targets/mouth/mouth-upperlip-volume-inflate.target": [
			"mouth",
			"mouth",
			"upperlip",
			"volume",
			"inflate"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-young-averagemuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/breast-point-min.target": [
			"breast",
			"breast",
			"point",
			"min"
		],
		"data/targets/ears/l-ear-height-min.target": [
			"ears",
			"l",
			"ear",
			"height",
			"min"
		],
		"data/targets/asym/asym-top-2-r.target": [
			"asym",
			"asym",
			"top",
			"2",
			"r"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/measure/measure-lowerarmlenght-decrease.target": [
			"measure",
			"measure",
			"lowerarmlenght",
			"decrease"
		],
		"data/targets/armslegs/r-hand-fingers-distance-decr.target": [
			"armslegs",
			"r",
			"hand",
			"fingers",
			"distance",
			"decr"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/nose/nose-volume-point.target": [
			"nose",
			"nose",
			"volume",
			"point"
		],
		"data/targets/asym/asym-eye-8-l.target": [
			"asym",
			"asym",
			"eye",
			"8",
			"l"
		],
		"data/targets/expression/units/caucasian/nose-right-elevation.target": [
			"expression",
			"units",
			"nose",
			"right",
			"elevation"
		],
		"data/targets/eyes/l-eye-push1-out.target": [
			"eyes",
			"l",
			"eye",
			"push1",
			"out"
		],
		"data/targets/expression/units/asian/eyebrows-right-inner-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"inner",
			"up"
		],
		"data/targets/macrodetails/height/male-child-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/female-young-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-minmuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-old-averagemuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/neck/neck-scale-vert-more.target": [
			"neck",
			"neck",
			"scale",
			"vert",
			"more"
		],
		"data/targets/armslegs/l-upperleg-skinny.target": [
			"armslegs",
			"l",
			"upperleg",
			"skinny"
		],
		"data/targets/macrodetails/proportions/male-child-maxmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-corner2-down.target": [
			"eyes",
			"l",
			"eye",
			"corner2",
			"down"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-male-baby-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/male-young-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/hip/hip-trans-forward.target": [
			"hip",
			"hip",
			"trans",
			"forward"
		],
		"data/targets/macrodetails/universal-male-baby-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-female-old-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/female-old-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/neck/neck-trans-horiz-out.target": [
			"neck",
			"neck",
			"trans",
			"horiz",
			"out"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/genitals/penis-length-max.target": [
			"genitals",
			"penis",
			"length",
			"max"
		],
		"data/targets/measure/measure-hips-decrease.target": [
			"measure",
			"measure",
			"hips",
			"decrease"
		],
		"data/targets/expression/units/caucasian/nose-left-dilatation.target": [
			"expression",
			"units",
			"nose",
			"left",
			"dilatation"
		],
		"data/targets/expression/units/caucasian/eyebrows-right-down.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"down"
		],
		"data/targets/head/head-trans-down.target": [
			"head",
			"head",
			"trans",
			"down"
		],
		"data/targets/macrodetails/universal-female-baby-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/male-child-minmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-upperarm-muscle-decr.target": [
			"armslegs",
			"r",
			"upperarm",
			"muscle",
			"decr"
		],
		"data/targets/macrodetails/height/female-child-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-foot-trans-out.target": [
			"armslegs",
			"l",
			"foot",
			"trans",
			"out"
		],
		"data/targets/mouth/mouth-trans-up.target": [
			"mouth",
			"mouth",
			"trans",
			"up"
		],
		"data/targets/macrodetails/height/male-old-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/male-baby-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/caucasian/nose-left-elevation.target": [
			"expression",
			"units",
			"nose",
			"left",
			"elevation"
		],
		"data/targets/macrodetails/caucasian-female-baby.target": [
			"macrodetails"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/caucasian/eye-right-slit.target": [
			"expression",
			"units",
			"eye",
			"right",
			"slit"
		],
		"data/targets/ears/r-ear-shape1-pointed.target": [
			"ears",
			"r",
			"ear",
			"shape1",
			"pointed"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/breast-dist-min.target": [
			"breast",
			"breast",
			"dist",
			"min"
		],
		"data/targets/ears/l-ear-size-small.target": [
			"ears",
			"l",
			"ear",
			"size",
			"small"
		],
		"data/targets/nose/nose-width3-min.target": [
			"nose",
			"nose",
			"width3",
			"min"
		],
		"data/targets/breast/breast-volume-vert-down.target": [
			"breast",
			"breast",
			"volume",
			"vert",
			"down"
		],
		"data/targets/chin/chin-prominent-more.target": [
			"chin",
			"chin",
			"prominent",
			"more"
		],
		"data/targets/mouth/mouth-upperlip-volume-deflate.target": [
			"mouth",
			"mouth",
			"upperlip",
			"volume",
			"deflate"
		],
		"data/targets/mouth/mouth-cupidsbow-decr.target": [
			"mouth",
			"mouth",
			"cupidsbow",
			"decr"
		],
		"data/targets/eyes/l-eye-bag-max.target": [
			"eyes",
			"l",
			"eye",
			"bag",
			"max"
		],
		"data/targets/macrodetails/proportions/male-young-minmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/measure/measure-shoulder-increase.target": [
			"measure",
			"measure",
			"shoulder",
			"increase"
		],
		"data/targets/macrodetails/african-male-baby.target": [
			"macrodetails"
		],
		"data/targets/expression/units/caucasian/eyebrows-left-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"up"
		],
		"data/targets/ears/r-ear-trans-depth-forward.target": [
			"ears",
			"r",
			"ear",
			"trans",
			"depth",
			"forward"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-epicanthus-in.target": [
			"eyes",
			"l",
			"eye",
			"epicanthus",
			"in"
		],
		"data/targets/armslegs/r-upperleg-scale-horiz-decr.target": [
			"armslegs",
			"r",
			"upperleg",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/macrodetails/universal-male-baby-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/mouth/mouth-lowerlip-ext-down.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"ext",
			"down"
		],
		"data/targets/breast/female-young-minmuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/asian-female-young.target": [
			"macrodetails"
		],
		"data/targets/ears/l-ear-rot-forward.target": [
			"ears",
			"l",
			"ear",
			"rot",
			"forward"
		],
		"data/targets/armslegs/r-hand-trans-in.target": [
			"armslegs",
			"r",
			"hand",
			"trans",
			"in"
		],
		"data/targets/legs/legs-upperlegheight-decr.target": [
			"legs",
			"legs",
			"upperlegheight",
			"decr"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/ears/l-ear-shape2-round.target": [
			"ears",
			"l",
			"ear",
			"shape2",
			"round"
		],
		"data/targets/ears/r-ear-height-min.target": [
			"ears",
			"r",
			"ear",
			"height",
			"min"
		],
		"data/targets/macrodetails/height/male-young-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/eyebrows-left-inner-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"inner",
			"up"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/mouth-pursing.target": [
			"expression",
			"units",
			"mouth",
			"pursing"
		],
		"data/targets/breast/female-old-minmuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-old-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-maxmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-upperarm-shoulder-muscle-incr.target": [
			"armslegs",
			"r",
			"upperarm",
			"shoulder",
			"muscle",
			"incr"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-hand-fingers-distance-decr.target": [
			"armslegs",
			"l",
			"hand",
			"fingers",
			"distance",
			"decr"
		],
		"data/targets/nose/nose-nostril-width-min.target": [
			"nose",
			"nose",
			"nostril",
			"width",
			"min"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-old-minmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/head/head-scale-depth-less.target": [
			"head",
			"head",
			"scale",
			"depth",
			"less"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/mouth-elevation.target": [
			"expression",
			"units",
			"mouth",
			"elevation"
		],
		"data/targets/armslegs/l-foot-scale-depth-incr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/macrodetails/proportions/male-old-averagemuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/caucasian/nose-depression.target": [
			"expression",
			"units",
			"nose",
			"depression"
		],
		"data/targets/eyes/r-eye-eyefold-angle-up.target": [
			"eyes",
			"r",
			"eye",
			"eyefold",
			"angle",
			"up"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/caucasian/eyebrows-right-extern-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"extern",
			"up"
		],
		"data/targets/expression/units/caucasian/nose-compression.target": [
			"expression",
			"units",
			"nose",
			"compression"
		],
		"data/targets/macrodetails/proportions/female-old-maxmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/measure/measure-hips-increase.target": [
			"measure",
			"measure",
			"hips",
			"increase"
		],
		"data/targets/eyes/l-eye-height1-min.target": [
			"eyes",
			"l",
			"eye",
			"height1",
			"min"
		],
		"data/targets/macrodetails/height/female-old-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/head/head-trans-forward.target": [
			"head",
			"head",
			"trans",
			"forward"
		],
		"data/targets/measure/measure-waist-increase.target": [
			"measure",
			"measure",
			"waist",
			"increase"
		],
		"data/targets/armslegs/r-lowerarm-muscle-incr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"muscle",
			"incr"
		],
		"data/targets/mouth/mouth-lowerlip-volume-inflate.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"volume",
			"inflate"
		],
		"data/targets/asym/asym-nose-4-r.target": [
			"asym",
			"asym",
			"nose",
			"4",
			"r"
		],
		"data/targets/armslegs/l-lowerleg-muscle-incr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"muscle",
			"incr"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/mouth-open.target": [
			"expression",
			"units",
			"mouth",
			"open"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/mouth/mouth-dimples-out.target": [
			"mouth",
			"mouth",
			"dimples",
			"out"
		],
		"data/targets/eyes/l-eye-corner1-down.target": [
			"eyes",
			"l",
			"eye",
			"corner1",
			"down"
		],
		"data/targets/macrodetails/universal-male-old-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/expression/units/african/mouth-upward-retraction.target": [
			"expression",
			"units",
			"mouth",
			"upward",
			"retraction"
		],
		"data/targets/genitals/penis-testicles-min.target": [
			"genitals",
			"penis",
			"testicles",
			"min"
		],
		"data/targets/head/head-back-scale-depth-more.target": [
			"head",
			"head",
			"back",
			"scale",
			"depth",
			"more"
		],
		"data/targets/macrodetails/proportions/male-old-maxmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/torso/torso-scale-depth-decr.target": [
			"torso",
			"torso",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/macrodetails/universal-male-child-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/measure/measure-napetowaist-increase.target": [
			"measure",
			"measure",
			"napetowaist",
			"increase"
		],
		"data/targets/stomach/stomach-pregnant-decr.target": [
			"stomach",
			"stomach",
			"pregnant",
			"decr"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/breast-volume-vert-up.target": [
			"breast",
			"breast",
			"volume",
			"vert",
			"up"
		],
		"data/targets/nose/nose-compression-uncompress.target": [
			"nose",
			"nose",
			"compression",
			"uncompress"
		],
		"data/targets/chin/chin-height-min.target": [
			"chin",
			"chin",
			"height",
			"min"
		],
		"data/targets/expression/units/asian/nose-left-elevation.target": [
			"expression",
			"units",
			"nose",
			"left",
			"elevation"
		],
		"data/targets/measure/measure-upperarmlenght-increase.target": [
			"measure",
			"measure",
			"upperarmlenght",
			"increase"
		],
		"data/targets/nose/nose-nostril-width-max.target": [
			"nose",
			"nose",
			"nostril",
			"width",
			"max"
		],
		"data/targets/macrodetails/height/female-child-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/male-child-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/female-old-averagemuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/caucasian-male-young.target": [
			"macrodetails"
		],
		"data/targets/breast/female-young-minmuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-old-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-scale-depth-incr.target": [
			"nose",
			"nose",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/expression/units/caucasian/mouth-retraction.target": [
			"expression",
			"units",
			"mouth",
			"retraction"
		],
		"data/targets/macrodetails/proportions/female-young-maxmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asymm-breast-1-l.target": [
			"asym",
			"asymm",
			"breast",
			"1",
			"l"
		],
		"data/targets/macrodetails/universal-male-child-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-male-young-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/hip/hip-trans-backward.target": [
			"hip",
			"hip",
			"trans",
			"backward"
		],
		"data/targets/nose/nose-trans-horiz-in.target": [
			"nose",
			"nose",
			"trans",
			"horiz",
			"in"
		],
		"data/targets/eyes/r-eye-eyefold-concave.target": [
			"eyes",
			"r",
			"eye",
			"eyefold",
			"concave"
		],
		"data/targets/macrodetails/african-male-old.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/universal-male-child-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/head/head-square.target": [
			"head",
			"head",
			"square"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-brown-1-l.target": [
			"asym",
			"asym",
			"brown",
			"1",
			"l"
		],
		"data/targets/armslegs/r-foot-scale-horiz-decr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/asym/asym-ear-1-l.target": [
			"asym",
			"asym",
			"ear",
			"1",
			"l"
		],
		"data/targets/asym/asym-top-2-l.target": [
			"asym",
			"asym",
			"top",
			"2",
			"l"
		],
		"data/targets/mouth/mouth-lowerlip-middle-up.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"middle",
			"up"
		],
		"data/targets/macrodetails/universal-male-old-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/female-old-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-width1-min.target": [
			"nose",
			"nose",
			"width1",
			"min"
		],
		"data/targets/macrodetails/height/female-baby-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-minmuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/head/head-trans-backward.target": [
			"head",
			"head",
			"trans",
			"backward"
		],
		"data/targets/eyes/l-eye-height3-min.target": [
			"eyes",
			"l",
			"eye",
			"height3",
			"min"
		],
		"data/targets/head/head-oval.target": [
			"head",
			"head",
			"oval"
		],
		"data/targets/macrodetails/proportions/female-child-averagemuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/nose/nose-scale-vert-decr.target": [
			"nose",
			"nose",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/macrodetails/height/female-young-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/ears/l-ear-wing-out.target": [
			"ears",
			"l",
			"ear",
			"wing",
			"out"
		],
		"data/targets/armslegs/l-upperleg-scale-horiz-incr.target": [
			"armslegs",
			"l",
			"upperleg",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/armslegs/l-upperarm-scale-horiz-incr.target": [
			"armslegs",
			"l",
			"upperarm",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/measure/measure-wrist-increase.target": [
			"measure",
			"measure",
			"wrist",
			"increase"
		],
		"data/targets/armslegs/r-upperarm-scale-vert-decr.target": [
			"armslegs",
			"r",
			"upperarm",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/cheek/l-cheek-trans-vert-up.target": [
			"cheek",
			"l",
			"cheek",
			"trans",
			"vert",
			"up"
		],
		"data/targets/eyes/l-eye-bag-in.target": [
			"eyes",
			"l",
			"eye",
			"bag",
			"in"
		],
		"data/targets/measure/measure-ankle-increase.target": [
			"measure",
			"measure",
			"ankle",
			"increase"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/nose-right-dilatation.target": [
			"expression",
			"units",
			"nose",
			"right",
			"dilatation"
		],
		"data/targets/ears/r-ear-trans-depth-backward.target": [
			"ears",
			"r",
			"ear",
			"trans",
			"depth",
			"backward"
		],
		"data/targets/armslegs/l-upperleg-fat.target": [
			"armslegs",
			"l",
			"upperleg",
			"fat"
		],
		"data/targets/macrodetails/proportions/female-child-minmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-hand-fingers-length-incr.target": [
			"armslegs",
			"r",
			"hand",
			"fingers",
			"length",
			"incr"
		],
		"data/targets/mouth/mouth-scale-depth-incr.target": [
			"mouth",
			"mouth",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/neck/neck-trans-depth-backward.target": [
			"neck",
			"neck",
			"trans",
			"depth",
			"backward"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-temple-2-r.target": [
			"asym",
			"asym",
			"temple",
			"2",
			"r"
		],
		"data/targets/macrodetails/proportions/female-child-maxmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/african/nose-left-elevation.target": [
			"expression",
			"units",
			"nose",
			"left",
			"elevation"
		],
		"data/targets/torso/torso-vshape-less.target": [
			"torso",
			"torso",
			"vshape",
			"less"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/chin/chin-jaw-drop-less.target": [
			"chin",
			"chin",
			"jaw",
			"drop",
			"less"
		],
		"data/targets/macrodetails/asian-male-baby.target": [
			"macrodetails"
		],
		"data/targets/asym/asym-ear-4-r.target": [
			"asym",
			"asym",
			"ear",
			"4",
			"r"
		],
		"data/targets/mouth/mouth-lowerlip-width-min.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"width",
			"min"
		],
		"data/targets/nose/nose-greek-moregreek.target": [
			"nose",
			"nose",
			"greek",
			"moregreek"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-old-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-compression-compress.target": [
			"nose",
			"nose",
			"compression",
			"compress"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/head/head-scale-depth-more.target": [
			"head",
			"head",
			"scale",
			"depth",
			"more"
		],
		"data/targets/eyes/l-eye-epicanthus-out.target": [
			"eyes",
			"l",
			"eye",
			"epicanthus",
			"out"
		],
		"data/targets/chin/chin-prognathism-more.target": [
			"chin",
			"chin",
			"prognathism",
			"more"
		],
		"data/targets/macrodetails/height/female-child-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/asian/mouth-part-later.target": [
			"expression",
			"units",
			"mouth",
			"part",
			"later"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-upperarm-shoulder-muscle-decr.target": [
			"armslegs",
			"l",
			"upperarm",
			"shoulder",
			"muscle",
			"decr"
		],
		"data/targets/expression/units/asian/eyebrows-left-extern-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"extern",
			"up"
		],
		"data/targets/ears/r-ear-rot-backward.target": [
			"ears",
			"r",
			"ear",
			"rot",
			"backward"
		],
		"data/targets/eyes/l-eye-height2-min.target": [
			"eyes",
			"l",
			"eye",
			"height2",
			"min"
		],
		"data/targets/legs/legs-lowerlegheight-incr.target": [
			"legs",
			"legs",
			"lowerlegheight",
			"incr"
		],
		"data/targets/armslegs/l-lowerarm-scale-horiz-incr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/macrodetails/height/male-old-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/african/eye-right-closure.target": [
			"expression",
			"units",
			"eye",
			"right",
			"closure"
		],
		"data/targets/macrodetails/height/female-young-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/caucasian/mouth-pursing.target": [
			"expression",
			"units",
			"mouth",
			"pursing"
		],
		"data/targets/head/head-trans-out.target": [
			"head",
			"head",
			"trans",
			"out"
		],
		"data/targets/expression/units/african/mouth-corner-puller.target": [
			"expression",
			"units",
			"mouth",
			"corner",
			"puller"
		],
		"data/targets/macrodetails/proportions/female-child-maxmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/male-baby-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-male-old-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/female-young-minmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-child-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/asym/asym-eye-4-r.target": [
			"asym",
			"asym",
			"eye",
			"4",
			"r"
		],
		"data/targets/macrodetails/universal-male-young-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/measure/measure-upperarmlenght-decrease.target": [
			"measure",
			"measure",
			"upperarmlenght",
			"decrease"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/asym/asymm-trunk-1-l.target": [
			"asym",
			"asymm",
			"trunk",
			"1",
			"l"
		],
		"data/targets/armslegs/l-upperarm-scale-horiz-decr.target": [
			"armslegs",
			"l",
			"upperarm",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/macrodetails/universal-female-old-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/caucasian-male-baby.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/universal-female-young-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/female-child-averagemuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-lowerleg-skinny.target": [
			"armslegs",
			"l",
			"lowerleg",
			"skinny"
		],
		"data/targets/measure/measure-bust-increase.target": [
			"measure",
			"measure",
			"bust",
			"increase"
		],
		"data/targets/armslegs/l-foot-trans-in.target": [
			"armslegs",
			"l",
			"foot",
			"trans",
			"in"
		],
		"data/targets/eyes/r-eye-push1-out.target": [
			"eyes",
			"r",
			"eye",
			"push1",
			"out"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/ears/r-ear-shape2-square.target": [
			"ears",
			"r",
			"ear",
			"shape2",
			"square"
		],
		"data/targets/measure/measure-lowerlegheight-decrease.target": [
			"measure",
			"measure",
			"lowerlegheight",
			"decrease"
		],
		"data/targets/armslegs/r-foot-scale-incr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"incr"
		],
		"data/targets/ears/l-ear-width-min.target": [
			"ears",
			"l",
			"ear",
			"width",
			"min"
		],
		"data/targets/armslegs/r-foot-scale-depth-incr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/armslegs/r-hand-fingers-diameter-decr.target": [
			"armslegs",
			"r",
			"hand",
			"fingers",
			"diameter",
			"decr"
		],
		"data/targets/macrodetails/proportions/male-young-minmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/female-baby-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/african/eyebrows-right-extern-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"extern",
			"up"
		],
		"data/targets/expression/units/african/nose-right-dilatation.target": [
			"expression",
			"units",
			"nose",
			"right",
			"dilatation"
		],
		"data/targets/breast/female-child-minmuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-child-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/cheek/r-cheek-bones-out.target": [
			"cheek",
			"r",
			"cheek",
			"bones",
			"out"
		],
		"data/targets/asym/asym-brown-2-r.target": [
			"asym",
			"asym",
			"brown",
			"2",
			"r"
		],
		"data/targets/macrodetails/proportions/male-young-averagemuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/universal-male-child-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/mouth-retraction.target": [
			"expression",
			"units",
			"mouth",
			"retraction"
		],
		"data/targets/macrodetails/proportions/male-old-averagemuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-lowerleg-scale-horiz-incr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/expression/units/asian/eyebrows-right-extern-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"extern",
			"up"
		],
		"data/targets/measure/measure-waist-decrease.target": [
			"measure",
			"measure",
			"waist",
			"decrease"
		],
		"data/targets/hip/hip-scale-depth-incr.target": [
			"hip",
			"hip",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/ears/r-ear-trans-vert-up.target": [
			"ears",
			"r",
			"ear",
			"trans",
			"vert",
			"up"
		],
		"data/targets/measure/measure-underbust-decrease.target": [
			"measure",
			"measure",
			"underbust",
			"decrease"
		],
		"data/targets/chin/chin-cleft-out.target": [
			"chin",
			"chin",
			"cleft",
			"out"
		],
		"data/targets/macrodetails/proportions/male-old-averagemuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-old-minmuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/cheek/l-cheek-bones-in.target": [
			"cheek",
			"l",
			"cheek",
			"bones",
			"in"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-jaw-3-l.target": [
			"asym",
			"asym",
			"jaw",
			"3",
			"l"
		],
		"data/targets/macrodetails/asian-male-young.target": [
			"macrodetails"
		],
		"data/targets/torso/torso-trans-vert-down.target": [
			"torso",
			"torso",
			"trans",
			"vert",
			"down"
		],
		"data/targets/ears/r-ear-shape2-round.target": [
			"ears",
			"r",
			"ear",
			"shape2",
			"round"
		],
		"data/targets/eyebrows/eyebrows-angle-down.target": [
			"eyebrows",
			"eyebrows",
			"angle",
			"down"
		],
		"data/targets/macrodetails/universal-male-baby-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/neck/neck-double-more.target": [
			"neck",
			"neck",
			"double",
			"more"
		],
		"data/targets/expression/units/caucasian/eyebrows-left-inner-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"inner",
			"up"
		],
		"data/targets/armslegs/r-upperleg-scale-vert-incr.target": [
			"armslegs",
			"r",
			"upperleg",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-old-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/african/eyebrows-left-inner-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"inner",
			"up"
		],
		"data/targets/macrodetails/height/male-baby-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-upperleg-scale-depth-decr.target": [
			"armslegs",
			"l",
			"upperleg",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/macrodetails/universal-male-old-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/ears/r-ear-height-max.target": [
			"ears",
			"r",
			"ear",
			"height",
			"max"
		],
		"data/targets/ears/l-ear-lobe-max.target": [
			"ears",
			"l",
			"ear",
			"lobe",
			"max"
		],
		"data/targets/armslegs/r-foot-scale-horiz-incr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/head/head-age-less.target": [
			"head",
			"head",
			"age",
			"less"
		],
		"data/targets/macrodetails/height/male-old-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/female-old-minmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/female-child-maxmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/eyes/r-eye-move-out.target": [
			"eyes",
			"r",
			"eye",
			"move",
			"out"
		],
		"data/targets/breast/breast-point-max.target": [
			"breast",
			"breast",
			"point",
			"max"
		],
		"data/targets/asym/asym-cheek-2-l.target": [
			"asym",
			"asym",
			"cheek",
			"2",
			"l"
		],
		"data/targets/ears/r-ear-width-min.target": [
			"ears",
			"r",
			"ear",
			"width",
			"min"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-child-minmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asym-ear-4-l.target": [
			"asym",
			"asym",
			"ear",
			"4",
			"l"
		],
		"data/targets/macrodetails/proportions/female-young-minmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asym-nose-1-l.target": [
			"asym",
			"asym",
			"nose",
			"1",
			"l"
		],
		"data/targets/eyes/r-eye-height1-max.target": [
			"eyes",
			"r",
			"eye",
			"height1",
			"max"
		],
		"data/targets/mouth/mouth-scale-horiz-decr.target": [
			"mouth",
			"mouth",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/macrodetails/proportions/male-old-averagemuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/breast-dist-max.target": [
			"breast",
			"breast",
			"dist",
			"max"
		],
		"data/targets/breast/nipple-point-out.target": [
			"breast",
			"nipple",
			"point",
			"out"
		],
		"data/targets/armslegs/r-lowerarm-scale-vert-incr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/armslegs/l-lowerleg-scale-vert-decr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/macrodetails/proportions/male-old-minmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-hand-trans-out.target": [
			"armslegs",
			"r",
			"hand",
			"trans",
			"out"
		],
		"data/targets/macrodetails/proportions/female-old-maxmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-jaw-2-l.target": [
			"asym",
			"asym",
			"jaw",
			"2",
			"l"
		],
		"data/targets/measure/measure-upperlegheight-increase.target": [
			"measure",
			"measure",
			"upperlegheight",
			"increase"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-jaw-1-l.target": [
			"asym",
			"asym",
			"jaw",
			"1",
			"l"
		],
		"data/targets/expression/units/caucasian/mouth-part-later.target": [
			"expression",
			"units",
			"mouth",
			"part",
			"later"
		],
		"data/targets/expression/units/asian/eyebrows-right-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"up"
		],
		"data/targets/macrodetails/universal-female-child-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/male-child-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/torso/torso-trans-depth-backward.target": [
			"torso",
			"torso",
			"trans",
			"depth",
			"backward"
		],
		"data/targets/breast/female-old-minmuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-male-young-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-old-minmuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-upperarm-skinny.target": [
			"armslegs",
			"l",
			"upperarm",
			"skinny"
		],
		"data/targets/nose/nose-trans-vert-down.target": [
			"nose",
			"nose",
			"trans",
			"vert",
			"down"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-move-up.target": [
			"eyes",
			"r",
			"eye",
			"move",
			"up"
		],
		"data/targets/macrodetails/height/male-old-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/r-lowerleg-scale-horiz-incr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/macrodetails/height/female-young-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/caucasian/mouth-parling.target": [
			"expression",
			"units",
			"mouth",
			"parling"
		],
		"data/targets/eyes/r-eye-eyefold-angle-down.target": [
			"eyes",
			"r",
			"eye",
			"eyefold",
			"angle",
			"down"
		],
		"data/targets/ears/r-ear-width-max.target": [
			"ears",
			"r",
			"ear",
			"width",
			"max"
		],
		"data/targets/expression/units/caucasian/mouth-compression.target": [
			"expression",
			"units",
			"mouth",
			"compression"
		],
		"data/targets/neck/neck-trans-depth-forward.target": [
			"neck",
			"neck",
			"trans",
			"depth",
			"forward"
		],
		"data/targets/head/head-scale-horiz-less.target": [
			"head",
			"head",
			"scale",
			"horiz",
			"less"
		],
		"data/targets/macrodetails/height/male-baby-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-nose-3-l.target": [
			"asym",
			"asym",
			"nose",
			"3",
			"l"
		],
		"data/targets/forehead/forehead-trans-depth-backward.target": [
			"forehead",
			"forehead",
			"trans",
			"depth",
			"backward"
		],
		"data/targets/macrodetails/height/female-baby-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-old-minmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/legs/legs-upperlegheight-incr.target": [
			"legs",
			"legs",
			"upperlegheight",
			"incr"
		],
		"data/targets/forehead/forehead-nubian-more.target": [
			"forehead",
			"forehead",
			"nubian",
			"more"
		],
		"data/targets/macrodetails/proportions/female-old-minmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-lowerarm-fat.target": [
			"armslegs",
			"l",
			"lowerarm",
			"fat"
		],
		"data/targets/asym/asym-eye-2-l.target": [
			"asym",
			"asym",
			"eye",
			"2",
			"l"
		],
		"data/targets/ears/l-ear-width-max.target": [
			"ears",
			"l",
			"ear",
			"width",
			"max"
		],
		"data/targets/measure/measure-frontchest-increase.target": [
			"measure",
			"measure",
			"frontchest",
			"increase"
		],
		"data/targets/expression/units/african/eyebrows-left-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"up"
		],
		"data/targets/macrodetails/proportions/male-child-maxmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/female-child-averagemuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-foot-scale-horiz-incr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/macrodetails/universal-male-baby-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-female-child-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-bag-out.target": [
			"eyes",
			"l",
			"eye",
			"bag",
			"out"
		],
		"data/targets/macrodetails/height/male-baby-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/asian/eyebrows-left-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"up"
		],
		"data/targets/macrodetails/proportions/male-child-maxmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/stomach/stomach-navel-out.target": [
			"stomach",
			"stomach",
			"navel",
			"out"
		],
		"data/targets/pelvis/pelvis-tone-decr.target": [
			"pelvis",
			"pelvis",
			"tone",
			"decr"
		],
		"data/targets/eyes/r-eye-bag-max.target": [
			"eyes",
			"r",
			"eye",
			"bag",
			"max"
		],
		"data/targets/armslegs/l-foot-scale-depth-decr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/macrodetails/height/female-child-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-hand-fingers-distance-incr.target": [
			"armslegs",
			"l",
			"hand",
			"fingers",
			"distance",
			"incr"
		],
		"data/targets/asym/asym-eye-5-l.target": [
			"asym",
			"asym",
			"eye",
			"5",
			"l"
		],
		"data/targets/legs/legs-lowerlegheight-decr.target": [
			"legs",
			"legs",
			"lowerlegheight",
			"decr"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/hip/hip-trans-in.target": [
			"hip",
			"hip",
			"trans",
			"in"
		],
		"data/targets/armslegs/r-lowerleg-muscle-decr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"muscle",
			"decr"
		],
		"data/targets/measure/measure-calf-increase.target": [
			"measure",
			"measure",
			"calf",
			"increase"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/cheek/r-cheek-trans-vert-up.target": [
			"cheek",
			"r",
			"cheek",
			"trans",
			"vert",
			"up"
		],
		"data/targets/head/head-angle-out.target": [
			"head",
			"head",
			"angle",
			"out"
		],
		"data/targets/hip/hip-scale-horiz-decr.target": [
			"hip",
			"hip",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/nose/nose-volume-potato.target": [
			"nose",
			"nose",
			"volume",
			"potato"
		],
		"data/targets/torso/torso-trans-depth-forward.target": [
			"torso",
			"torso",
			"trans",
			"depth",
			"forward"
		],
		"data/targets/expression/units/asian/mouth-depression-retraction.target": [
			"expression",
			"units",
			"mouth",
			"depression",
			"retraction"
		],
		"data/targets/mouth/mouth-upperlip-width-max.target": [
			"mouth",
			"mouth",
			"upperlip",
			"width",
			"max"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-child-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-scale-horiz-decr.target": [
			"nose",
			"nose",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/macrodetails/height/male-old-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-child-maxmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asym-eye-3-l.target": [
			"asym",
			"asym",
			"eye",
			"3",
			"l"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-child-averagemuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/asian/eyebrows-right-down.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"down"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-lowerarm-scale-depth-incr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/expression/units/african/nose-right-elevation.target": [
			"expression",
			"units",
			"nose",
			"right",
			"elevation"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-bag-out.target": [
			"eyes",
			"r",
			"eye",
			"bag",
			"out"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-baby-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/caucasian/mouth-corner-puller.target": [
			"expression",
			"units",
			"mouth",
			"corner",
			"puller"
		],
		"data/targets/neck/neck-trans-horiz-in.target": [
			"neck",
			"neck",
			"trans",
			"horiz",
			"in"
		],
		"data/targets/macrodetails/height/female-young-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-flaring-decr.target": [
			"nose",
			"nose",
			"flaring",
			"decr"
		],
		"data/targets/nose/nose-point-width-less.target": [
			"nose",
			"nose",
			"point",
			"width",
			"less"
		],
		"data/targets/macrodetails/height/male-baby-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/cheek/r-cheek-volume-deflate.target": [
			"cheek",
			"r",
			"cheek",
			"volume",
			"deflate"
		],
		"data/targets/head/head-scale-horiz-more.target": [
			"head",
			"head",
			"scale",
			"horiz",
			"more"
		],
		"data/targets/macrodetails/height/female-child-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-averagemuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/eyes/r-eye-move-in.target": [
			"eyes",
			"r",
			"eye",
			"move",
			"in"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/caucasian/eye-right-closure.target": [
			"expression",
			"units",
			"eye",
			"right",
			"closure"
		],
		"data/targets/macrodetails/proportions/male-young-minmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/eyes/r-eye-push1-in.target": [
			"eyes",
			"r",
			"eye",
			"push1",
			"in"
		],
		"data/targets/head/head-rectangular.target": [
			"head",
			"head",
			"rectangular"
		],
		"data/targets/armslegs/r-foot-scale-vert-incr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/forehead/forehead-scale-vert-less.target": [
			"forehead",
			"forehead",
			"scale",
			"vert",
			"less"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-upperarm-muscle-decr.target": [
			"armslegs",
			"l",
			"upperarm",
			"muscle",
			"decr"
		],
		"data/targets/ears/l-ear-size-big.target": [
			"ears",
			"l",
			"ear",
			"size",
			"big"
		],
		"data/targets/macrodetails/asian-female-baby.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/asian-male-old.target": [
			"macrodetails"
		],
		"data/targets/torso/torso-muscle-pectoral-incr.target": [
			"torso",
			"torso",
			"muscle",
			"pectoral",
			"incr"
		],
		"data/targets/expression/units/caucasian/neck-platysma.target": [
			"expression",
			"units",
			"neck",
			"platysma"
		],
		"data/targets/expression/units/african/eye-left-opened-up.target": [
			"expression",
			"units",
			"eye",
			"left",
			"opened",
			"up"
		],
		"data/targets/nose/nose-point-down.target": [
			"nose",
			"nose",
			"point",
			"down"
		],
		"data/targets/chin/chin-jaw-drop-more.target": [
			"chin",
			"chin",
			"jaw",
			"drop",
			"more"
		],
		"data/targets/macrodetails/universal-female-baby-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-upperleg-fat.target": [
			"armslegs",
			"r",
			"upperleg",
			"fat"
		],
		"data/targets/torso/torso-scale-vert-incr.target": [
			"torso",
			"torso",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/armslegs/l-upperarm-muscle-incr.target": [
			"armslegs",
			"l",
			"upperarm",
			"muscle",
			"incr"
		],
		"data/targets/eyes/l-eye-height1-max.target": [
			"eyes",
			"l",
			"eye",
			"height1",
			"max"
		],
		"data/targets/ears/r-ear-flap-in.target": [
			"ears",
			"r",
			"ear",
			"flap",
			"in"
		],
		"data/targets/macrodetails/height/female-baby-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/african-male-young.target": [
			"macrodetails"
		],
		"data/targets/eyes/l-eye-eyefold-up.target": [
			"eyes",
			"l",
			"eye",
			"eyefold",
			"up"
		],
		"data/targets/nose/nose-nostrils-angle-up.target": [
			"nose",
			"nose",
			"nostrils",
			"angle",
			"up"
		],
		"data/targets/cheek/r-cheek-inner-deflate.target": [
			"cheek",
			"r",
			"cheek",
			"inner",
			"deflate"
		],
		"data/targets/nose/nose-width3-max.target": [
			"nose",
			"nose",
			"width3",
			"max"
		],
		"data/targets/macrodetails/height/female-young-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/r-upperarm-scale-horiz-incr.target": [
			"armslegs",
			"r",
			"upperarm",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/mouth/mouth-upperlip-middle-down.target": [
			"mouth",
			"mouth",
			"upperlip",
			"middle",
			"down"
		],
		"data/targets/macrodetails/height/female-baby-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/r-foot-trans-out.target": [
			"armslegs",
			"r",
			"foot",
			"trans",
			"out"
		],
		"data/targets/macrodetails/height/female-old-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/mouth/mouth-trans-out.target": [
			"mouth",
			"mouth",
			"trans",
			"out"
		],
		"data/targets/asym/asymm-breast-1-r.target": [
			"asym",
			"asymm",
			"breast",
			"1",
			"r"
		],
		"data/targets/ears/l-ear-trans-vert-down.target": [
			"ears",
			"l",
			"ear",
			"trans",
			"vert",
			"down"
		],
		"data/targets/macrodetails/proportions/male-young-averagemuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-bag-min.target": [
			"eyes",
			"r",
			"eye",
			"bag",
			"min"
		],
		"data/targets/measure/measure-neckcirc-increase.target": [
			"measure",
			"measure",
			"neckcirc",
			"increase"
		],
		"data/targets/mouth/mouth-laugh-lines-out.target": [
			"mouth",
			"mouth",
			"laugh",
			"lines",
			"out"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-child-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-scale-horiz-incr.target": [
			"nose",
			"nose",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/nose/nose-greek-lessgreek.target": [
			"nose",
			"nose",
			"greek",
			"lessgreek"
		],
		"data/targets/measure/measure-shoulder-decrease.target": [
			"measure",
			"measure",
			"shoulder",
			"decrease"
		],
		"data/targets/armslegs/r-upperarm-scale-vert-incr.target": [
			"armslegs",
			"r",
			"upperarm",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-young-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/torso/torso-vshape-more.target": [
			"torso",
			"torso",
			"vshape",
			"more"
		],
		"data/targets/macrodetails/height/male-baby-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-male-old-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-minmuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-upperarm-scale-depth-incr.target": [
			"armslegs",
			"l",
			"upperarm",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/macrodetails/height/male-child-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/caucasian/eye-left-opened-up.target": [
			"expression",
			"units",
			"eye",
			"left",
			"opened",
			"up"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/torso/torso-scale-depth-incr.target": [
			"torso",
			"torso",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-male-old-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/measure/measure-kneecirc-decrease.target": [
			"measure",
			"measure",
			"kneecirc",
			"decrease"
		],
		"data/targets/ears/l-ear-height-max.target": [
			"ears",
			"l",
			"ear",
			"height",
			"max"
		],
		"data/targets/asym/asym-eye-7-l.target": [
			"asym",
			"asym",
			"eye",
			"7",
			"l"
		],
		"data/targets/measure/measure-thighcirc-decrease.target": [
			"measure",
			"measure",
			"thighcirc",
			"decrease"
		],
		"data/targets/armslegs/l-lowerleg-scale-depth-incr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-move-in.target": [
			"eyes",
			"l",
			"eye",
			"move",
			"in"
		],
		"data/targets/armslegs/r-hand-fingers-diameter-incr.target": [
			"armslegs",
			"r",
			"hand",
			"fingers",
			"diameter",
			"incr"
		],
		"data/targets/asym/asym-ear-2-l.target": [
			"asym",
			"asym",
			"ear",
			"2",
			"l"
		],
		"data/targets/armslegs/r-foot-trans-down.target": [
			"armslegs",
			"r",
			"foot",
			"trans",
			"down"
		],
		"data/targets/macrodetails/height/female-young-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/african/mouth-eversion.target": [
			"expression",
			"units",
			"mouth",
			"eversion"
		],
		"data/targets/breast/female-old-minmuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-old-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/measure/measure-bust-decrease.target": [
			"measure",
			"measure",
			"bust",
			"decrease"
		],
		"data/targets/asym/asym-eye-5-r.target": [
			"asym",
			"asym",
			"eye",
			"5",
			"r"
		],
		"data/targets/nose/nose-nostrils-angle-down.target": [
			"nose",
			"nose",
			"nostrils",
			"angle",
			"down"
		],
		"data/targets/macrodetails/height/male-young-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/eyes/r-eye-bag-height-min.target": [
			"eyes",
			"r",
			"eye",
			"bag",
			"height",
			"min"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-young-averagemuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/head/head-diamond.target": [
			"head",
			"head",
			"diamond"
		],
		"data/targets/eyes/r-eye-size-big.target": [
			"eyes",
			"r",
			"eye",
			"size",
			"big"
		],
		"data/targets/eyes/r-eye-height3-max.target": [
			"eyes",
			"r",
			"eye",
			"height3",
			"max"
		],
		"data/targets/armslegs/l-lowerarm-scale-vert-decr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/macrodetails/height/male-child-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-curve-concave.target": [
			"nose",
			"nose",
			"curve",
			"concave"
		],
		"data/targets/macrodetails/height/male-baby-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/cheek/l-cheek-inner-inflate.target": [
			"cheek",
			"l",
			"cheek",
			"inner",
			"inflate"
		],
		"data/targets/breast/breast-trans-vert-up.target": [
			"breast",
			"breast",
			"trans",
			"vert",
			"up"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-old-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/mouth/mouth-lowerlip-width-max.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"width",
			"max"
		],
		"data/targets/asym/asymm-trunk-1-r.target": [
			"asym",
			"asymm",
			"trunk",
			"1",
			"r"
		],
		"data/targets/macrodetails/height/male-child-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-lowerarm-skinny.target": [
			"armslegs",
			"r",
			"lowerarm",
			"skinny"
		],
		"data/targets/asym/asym-mouth-1-l.target": [
			"asym",
			"asym",
			"mouth",
			"1",
			"l"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyebrows/eyebrows-trans-vert-more.target": [
			"eyebrows",
			"eyebrows",
			"trans",
			"vert",
			"more"
		],
		"data/targets/macrodetails/proportions/male-young-minmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-lowerleg-fat.target": [
			"armslegs",
			"r",
			"lowerleg",
			"fat"
		],
		"data/targets/measure/measure-neckheight-increase.target": [
			"measure",
			"measure",
			"neckheight",
			"increase"
		],
		"data/targets/cheek/l-cheek-volume-inflate.target": [
			"cheek",
			"l",
			"cheek",
			"volume",
			"inflate"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-cheek-1-l.target": [
			"asym",
			"asym",
			"cheek",
			"1",
			"l"
		],
		"data/targets/armslegs/l-foot-scale-vert-incr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/macrodetails/height/female-child-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/female-young-minmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/female-baby-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/mouth/mouth-laugh-lines-in.target": [
			"mouth",
			"mouth",
			"laugh",
			"lines",
			"in"
		],
		"data/targets/eyebrows/eyebrows-trans-depth-less.target": [
			"eyebrows",
			"eyebrows",
			"trans",
			"depth",
			"less"
		],
		"data/targets/mouth/mouth-scale-vert-decr.target": [
			"mouth",
			"mouth",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-upperarm-fat.target": [
			"armslegs",
			"r",
			"upperarm",
			"fat"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-child-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/female-old-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-hand-fingers-length-incr.target": [
			"armslegs",
			"l",
			"hand",
			"fingers",
			"length",
			"incr"
		],
		"data/targets/expression/units/caucasian/eye-left-closure.target": [
			"expression",
			"units",
			"eye",
			"left",
			"closure"
		],
		"data/targets/macrodetails/universal-female-young-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/stomach/stomach-navel-up.target": [
			"stomach",
			"stomach",
			"navel",
			"up"
		],
		"data/targets/macrodetails/height/male-young-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/head/head-scale-vert-less.target": [
			"head",
			"head",
			"scale",
			"vert",
			"less"
		],
		"data/targets/eyes/r-eye-move-down.target": [
			"eyes",
			"r",
			"eye",
			"move",
			"down"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-leg-genu-valgus.target": [
			"armslegs",
			"l",
			"leg",
			"genu",
			"valgus"
		],
		"data/targets/macrodetails/universal-male-child-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/forehead/forehead-temple-in.target": [
			"forehead",
			"forehead",
			"temple",
			"in"
		],
		"data/targets/forehead/forehead-trans-depth-forward.target": [
			"forehead",
			"forehead",
			"trans",
			"depth",
			"forward"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-child-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-upperarm-scale-vert-decr.target": [
			"armslegs",
			"l",
			"upperarm",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/mouth/mouth-lowerlip-middle-down.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"middle",
			"down"
		],
		"data/targets/macrodetails/height/male-child-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/female-old-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/ears/l-ear-rot-backward.target": [
			"ears",
			"l",
			"ear",
			"rot",
			"backward"
		],
		"data/targets/macrodetails/proportions/female-young-maxmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/hip/hip-scale-depth-decr.target": [
			"hip",
			"hip",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/eyes/r-eye-height2-min.target": [
			"eyes",
			"r",
			"eye",
			"height2",
			"min"
		],
		"data/targets/mouth/mouth-upperlip-height-min.target": [
			"mouth",
			"mouth",
			"upperlip",
			"height",
			"min"
		],
		"data/targets/macrodetails/height/male-child-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-male-child-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/nose-depression.target": [
			"expression",
			"units",
			"nose",
			"depression"
		],
		"data/targets/macrodetails/universal-male-baby-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/measure/measure-upperlegheight-decrease.target": [
			"measure",
			"measure",
			"upperlegheight",
			"decrease"
		],
		"data/targets/armslegs/r-upperleg-scale-depth-decr.target": [
			"armslegs",
			"r",
			"upperleg",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/mouth-parling.target": [
			"expression",
			"units",
			"mouth",
			"parling"
		],
		"data/targets/expression/units/caucasian/eye-right-opened-up.target": [
			"expression",
			"units",
			"eye",
			"right",
			"opened",
			"up"
		],
		"data/targets/macrodetails/universal-male-old-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/armslegs/l-hand-trans-out.target": [
			"armslegs",
			"l",
			"hand",
			"trans",
			"out"
		],
		"data/targets/macrodetails/proportions/female-old-maxmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-lowerleg-scale-depth-decr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/asym/asym-temple-1-r.target": [
			"asym",
			"asym",
			"temple",
			"1",
			"r"
		],
		"data/targets/macrodetails/proportions/female-young-minmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/head/head-trans-in.target": [
			"head",
			"head",
			"trans",
			"in"
		],
		"data/targets/macrodetails/asian-male-child.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/universal-female-old-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/expression/units/asian/mouth-eversion.target": [
			"expression",
			"units",
			"mouth",
			"eversion"
		],
		"data/targets/torso/torso-scale-horiz-incr.target": [
			"torso",
			"torso",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/expression/units/african/eye-left-closure.target": [
			"expression",
			"units",
			"eye",
			"left",
			"closure"
		],
		"data/targets/macrodetails/universal-female-child-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-old-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/cheek/l-cheek-volume-deflate.target": [
			"cheek",
			"l",
			"cheek",
			"volume",
			"deflate"
		],
		"data/targets/macrodetails/proportions/female-child-minmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/hip/hip-scale-vert-incr.target": [
			"hip",
			"hip",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-old-averagemuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-lowerleg-scale-horiz-decr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-eyefold-concave.target": [
			"eyes",
			"l",
			"eye",
			"eyefold",
			"concave"
		],
		"data/targets/eyes/l-eye-size-big.target": [
			"eyes",
			"l",
			"eye",
			"size",
			"big"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/torso/torso-trans-horiz-in.target": [
			"torso",
			"torso",
			"trans",
			"horiz",
			"in"
		],
		"data/targets/mouth/mouth-scale-depth-decr.target": [
			"mouth",
			"mouth",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/macrodetails/proportions/male-child-minmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/female-child-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/r-upperarm-scale-horiz-decr.target": [
			"armslegs",
			"r",
			"upperarm",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/armslegs/r-foot-trans-forward.target": [
			"armslegs",
			"r",
			"foot",
			"trans",
			"forward"
		],
		"data/targets/mouth/mouth-philtrum-volume-decrease.target": [
			"mouth",
			"mouth",
			"philtrum",
			"volume",
			"decrease"
		],
		"data/targets/macrodetails/proportions/male-old-maxmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-old-minmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-hand-scale-decr.target": [
			"armslegs",
			"l",
			"hand",
			"scale",
			"decr"
		],
		"data/targets/eyes/l-eye-corner2-up.target": [
			"eyes",
			"l",
			"eye",
			"corner2",
			"up"
		],
		"data/targets/macrodetails/height/female-young-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-female-baby-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/expression/units/african/mouth-protusion.target": [
			"expression",
			"units",
			"mouth",
			"protusion"
		],
		"data/targets/nose/nose-width1-max.target": [
			"nose",
			"nose",
			"width1",
			"max"
		],
		"data/targets/expression/units/asian/eye-left-slit.target": [
			"expression",
			"units",
			"eye",
			"left",
			"slit"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/mouth-protusion.target": [
			"expression",
			"units",
			"mouth",
			"protusion"
		],
		"data/targets/expression/units/caucasian/mouth-upward-retraction.target": [
			"expression",
			"units",
			"mouth",
			"upward",
			"retraction"
		],
		"data/targets/macrodetails/height/male-young-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-hand-fingers-diameter-decr.target": [
			"armslegs",
			"l",
			"hand",
			"fingers",
			"diameter",
			"decr"
		],
		"data/targets/armslegs/r-foot-trans-up.target": [
			"armslegs",
			"r",
			"foot",
			"trans",
			"up"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/mouth/mouth-scale-horiz-incr.target": [
			"mouth",
			"mouth",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/macrodetails/universal-female-old-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-male-young-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/eyes/r-eye-epicanthus-out.target": [
			"eyes",
			"r",
			"eye",
			"epicanthus",
			"out"
		],
		"data/targets/eyebrows/eyebrows-trans-depth-more.target": [
			"eyebrows",
			"eyebrows",
			"trans",
			"depth",
			"more"
		],
		"data/targets/macrodetails/universal-male-young-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-female-baby-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/armslegs/l-lowerarm-skinny.target": [
			"armslegs",
			"l",
			"lowerarm",
			"skinny"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/expression/units/caucasian/mouth-protusion.target": [
			"expression",
			"units",
			"mouth",
			"protusion"
		],
		"data/targets/asym/asym-jaw-1-r.target": [
			"asym",
			"asym",
			"jaw",
			"1",
			"r"
		],
		"data/targets/mouth/mouth-trans-backward.target": [
			"mouth",
			"mouth",
			"trans",
			"backward"
		],
		"data/targets/macrodetails/height/female-baby-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/cheek/l-cheek-bones-out.target": [
			"cheek",
			"l",
			"cheek",
			"bones",
			"out"
		],
		"data/targets/hip/hip-scale-horiz-incr.target": [
			"hip",
			"hip",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/armslegs/l-upperleg-muscle-incr.target": [
			"armslegs",
			"l",
			"upperleg",
			"muscle",
			"incr"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-child-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/nose/nose-trans-depth-forward.target": [
			"nose",
			"nose",
			"trans",
			"depth",
			"forward"
		],
		"data/targets/asym/asym-eye-1-l.target": [
			"asym",
			"asym",
			"eye",
			"1",
			"l"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/measure/measure-kneecirc-increase.target": [
			"measure",
			"measure",
			"kneecirc",
			"increase"
		],
		"data/targets/measure/measure-underbust-increase.target": [
			"measure",
			"measure",
			"underbust",
			"increase"
		],
		"data/targets/breast/female-young-minmuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-old-maxmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/eyes/l-eye-bag-height-max.target": [
			"eyes",
			"l",
			"eye",
			"bag",
			"height",
			"max"
		],
		"data/targets/expression/units/caucasian/mouth-depression-retraction.target": [
			"expression",
			"units",
			"mouth",
			"depression",
			"retraction"
		],
		"data/targets/macrodetails/universal-female-baby-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/armslegs/l-lowerleg-scale-vert-incr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/macrodetails/proportions/female-young-maxmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/male-child-maxmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-foot-scale-depth-decr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/asym/asym-nose-2-r.target": [
			"asym",
			"asym",
			"nose",
			"2",
			"r"
		],
		"data/targets/macrodetails/proportions/female-young-maxmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/hip/hip-scale-vert-decr.target": [
			"hip",
			"hip",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/mouth/mouth-upperlip-width-min.target": [
			"mouth",
			"mouth",
			"upperlip",
			"width",
			"min"
		],
		"data/targets/eyes/l-eye-eyefold-convex.target": [
			"eyes",
			"l",
			"eye",
			"eyefold",
			"convex"
		],
		"data/targets/mouth/mouth-cupidsbow-incr.target": [
			"mouth",
			"mouth",
			"cupidsbow",
			"incr"
		],
		"data/targets/armslegs/r-upperarm-shoulder-muscle-decr.target": [
			"armslegs",
			"r",
			"upperarm",
			"shoulder",
			"muscle",
			"decr"
		],
		"data/targets/macrodetails/caucasian-female-old.target": [
			"macrodetails"
		],
		"data/targets/ears/l-ear-trans-depth-backward.target": [
			"ears",
			"l",
			"ear",
			"trans",
			"depth",
			"backward"
		],
		"data/targets/macrodetails/height/male-young-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/chin/chin-bones-out.target": [
			"chin",
			"chin",
			"bones",
			"out"
		],
		"data/targets/macrodetails/universal-female-baby-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-male-baby-minmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/nose/nose-point-up.target": [
			"nose",
			"nose",
			"point",
			"up"
		],
		"data/targets/macrodetails/african-female-baby.target": [
			"macrodetails"
		],
		"data/targets/asym/asym-top-1-l.target": [
			"asym",
			"asym",
			"top",
			"1",
			"l"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/neck-platysma.target": [
			"expression",
			"units",
			"neck",
			"platysma"
		],
		"data/targets/eyes/r-eye-eyefold-down.target": [
			"eyes",
			"r",
			"eye",
			"eyefold",
			"down"
		],
		"data/targets/armslegs/r-upperleg-scale-depth-incr.target": [
			"armslegs",
			"r",
			"upperleg",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/armslegs/r-lowerarm-scale-vert-decr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/head/head-round.target": [
			"head",
			"head",
			"round"
		],
		"data/targets/macrodetails/proportions/male-young-minmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asym-eye-4-l.target": [
			"asym",
			"asym",
			"eye",
			"4",
			"l"
		],
		"data/targets/ears/l-ear-flap-out.target": [
			"ears",
			"l",
			"ear",
			"flap",
			"out"
		],
		"data/targets/macrodetails/proportions/female-child-minmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-upperleg-muscle-incr.target": [
			"armslegs",
			"r",
			"upperleg",
			"muscle",
			"incr"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-male-old-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-upperarm-skinny.target": [
			"armslegs",
			"r",
			"upperarm",
			"skinny"
		],
		"data/targets/asym/asym-jaw-3-r.target": [
			"asym",
			"asym",
			"jaw",
			"3",
			"r"
		],
		"data/targets/macrodetails/african-female-old.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/height/male-child-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-old-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-point-width-more.target": [
			"nose",
			"nose",
			"point",
			"width",
			"more"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/mouth/mouth-scale-vert-incr.target": [
			"mouth",
			"mouth",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/expression/units/african/mouth-elevation.target": [
			"expression",
			"units",
			"mouth",
			"elevation"
		],
		"data/targets/armslegs/l-foot-scale-decr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"decr"
		],
		"data/targets/asym/asym-mouth-2-r.target": [
			"asym",
			"asym",
			"mouth",
			"2",
			"r"
		],
		"data/targets/armslegs/r-lowerleg-muscle-incr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"muscle",
			"incr"
		],
		"data/targets/asym/asym-ear-3-r.target": [
			"asym",
			"asym",
			"ear",
			"3",
			"r"
		],
		"data/targets/macrodetails/height/female-child-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/hip/hip-waist-down.target": [
			"hip",
			"hip",
			"waist",
			"down"
		],
		"data/targets/armslegs/l-hand-fingers-diameter-incr.target": [
			"armslegs",
			"l",
			"hand",
			"fingers",
			"diameter",
			"incr"
		],
		"data/targets/macrodetails/universal-female-child-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/head/head-fat.target": [
			"head",
			"head",
			"fat"
		],
		"data/targets/head/head-skinny.target": [
			"head",
			"head",
			"skinny"
		],
		"data/targets/macrodetails/asian-female-old.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/caucasian-male-child.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/proportions/male-child-averagemuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/male-young-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/female-young-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-minmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/mouth/mouth-angles-down.target": [
			"mouth",
			"mouth",
			"angles",
			"down"
		],
		"data/targets/macrodetails/height/female-young-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/female-young-averagemuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/female-child-minmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/male-child-averagemuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/male-young-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/male-baby-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-minmuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-child-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-foot-trans-forward.target": [
			"armslegs",
			"l",
			"foot",
			"trans",
			"forward"
		],
		"data/targets/macrodetails/proportions/female-old-maxmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/asian/mouth-depression.target": [
			"expression",
			"units",
			"mouth",
			"depression"
		],
		"data/targets/macrodetails/universal-female-baby-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/asym/asym-nose-3-r.target": [
			"asym",
			"asym",
			"nose",
			"3",
			"r"
		],
		"data/targets/measure/measure-wrist-decrease.target": [
			"measure",
			"measure",
			"wrist",
			"decrease"
		],
		"data/targets/macrodetails/proportions/male-child-averagemuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/nose/nose-septumangle-decr.target": [
			"nose",
			"nose",
			"septumangle",
			"decr"
		],
		"data/targets/measure/measure-waisttohip-decrease.target": [
			"measure",
			"measure",
			"waisttohip",
			"decrease"
		],
		"data/targets/expression/units/caucasian/eyebrows-left-down.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"down"
		],
		"data/targets/macrodetails/proportions/female-old-averagemuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/female-child-minmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/universal-male-baby-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/universal-female-young-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/female-old-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/cheek/r-cheek-volume-inflate.target": [
			"cheek",
			"r",
			"cheek",
			"volume",
			"inflate"
		],
		"data/targets/expression/units/african/mouth-part-later.target": [
			"expression",
			"units",
			"mouth",
			"part",
			"later"
		],
		"data/targets/forehead/forehead-scale-vert-more.target": [
			"forehead",
			"forehead",
			"scale",
			"vert",
			"more"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/head/head-triangular.target": [
			"head",
			"head",
			"triangular"
		],
		"data/targets/macrodetails/african-male-child.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/height/male-young-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-eye-1-r.target": [
			"asym",
			"asym",
			"eye",
			"1",
			"r"
		],
		"data/targets/armslegs/r-lowerarm-scale-horiz-decr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/eyes/r-eye-eyefold-up.target": [
			"eyes",
			"r",
			"eye",
			"eyefold",
			"up"
		],
		"data/targets/head/head-invertedtriangular.target": [
			"head",
			"head",
			"invertedtriangular"
		],
		"data/targets/macrodetails/height/female-child-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-child-maxmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/hip/hip-waist-up.target": [
			"hip",
			"hip",
			"waist",
			"up"
		],
		"data/targets/head/head-trans-up.target": [
			"head",
			"head",
			"trans",
			"up"
		],
		"data/targets/expression/units/asian/eye-left-closure.target": [
			"expression",
			"units",
			"eye",
			"left",
			"closure"
		],
		"data/targets/armslegs/l-lowerarm-scale-depth-decr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/mouth/mouth-dimples-in.target": [
			"mouth",
			"mouth",
			"dimples",
			"in"
		],
		"data/targets/macrodetails/height/female-young-averagemuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-female-child-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/female-young-maxmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-eye-2-r.target": [
			"asym",
			"asym",
			"eye",
			"2",
			"r"
		],
		"data/targets/macrodetails/universal-female-old-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-upperleg-scale-vert-decr.target": [
			"armslegs",
			"r",
			"upperleg",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/nose/nose-trans-vert-up.target": [
			"nose",
			"nose",
			"trans",
			"vert",
			"up"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-young-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/armslegs/l-foot-trans-backward.target": [
			"armslegs",
			"l",
			"foot",
			"trans",
			"backward"
		],
		"data/targets/macrodetails/height/male-baby-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/ears/r-ear-wing-out.target": [
			"ears",
			"r",
			"ear",
			"wing",
			"out"
		],
		"data/targets/macrodetails/height/female-young-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/hip/hip-trans-up.target": [
			"hip",
			"hip",
			"trans",
			"up"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/male-young-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-minmuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/torso/torso-muscle-dorsi-decr.target": [
			"torso",
			"torso",
			"muscle",
			"dorsi",
			"decr"
		],
		"data/targets/macrodetails/height/female-child-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-trans-horiz-out.target": [
			"nose",
			"nose",
			"trans",
			"horiz",
			"out"
		],
		"data/targets/breast/nipple-size-min.target": [
			"breast",
			"nipple",
			"size",
			"min"
		],
		"data/targets/macrodetails/height/female-old-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/eyes/r-eye-height2-max.target": [
			"eyes",
			"r",
			"eye",
			"height2",
			"max"
		],
		"data/targets/neck/neck-scale-vert-less.target": [
			"neck",
			"neck",
			"scale",
			"vert",
			"less"
		],
		"data/targets/macrodetails/proportions/female-young-averagemuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/head/head-back-scale-depth-less.target": [
			"head",
			"head",
			"back",
			"scale",
			"depth",
			"less"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/mouth/mouth-upperlip-middle-up.target": [
			"mouth",
			"mouth",
			"upperlip",
			"middle",
			"up"
		],
		"data/targets/armslegs/r-lowerarm-scale-depth-incr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/breast/female-young-minmuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-hand-scale-decr.target": [
			"armslegs",
			"r",
			"hand",
			"scale",
			"decr"
		],
		"data/targets/macrodetails/proportions/male-old-minmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-upperarm-shoulder-muscle-incr.target": [
			"armslegs",
			"l",
			"upperarm",
			"shoulder",
			"muscle",
			"incr"
		],
		"data/targets/cheek/l-cheek-trans-vert-down.target": [
			"cheek",
			"l",
			"cheek",
			"trans",
			"vert",
			"down"
		],
		"data/targets/asym/asym-eye-8-r.target": [
			"asym",
			"asym",
			"eye",
			"8",
			"r"
		],
		"data/targets/neck/neck-trans-vert-up.target": [
			"neck",
			"neck",
			"trans",
			"vert",
			"up"
		],
		"data/targets/measure/measure-waisttohip-increase.target": [
			"measure",
			"measure",
			"waisttohip",
			"increase"
		],
		"data/targets/macrodetails/proportions/female-young-minmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/measure/measure-neckheight-decrease.target": [
			"measure",
			"measure",
			"neckheight",
			"decrease"
		],
		"data/targets/macrodetails/proportions/male-child-maxmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/male-old-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/asian/mouth-upward-retraction.target": [
			"expression",
			"units",
			"mouth",
			"upward",
			"retraction"
		],
		"data/targets/macrodetails/caucasian-male-old.target": [
			"macrodetails"
		],
		"data/targets/breast/female-child-minmuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-child-maxmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-lowerarm-scale-horiz-incr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/armslegs/l-upperarm-fat.target": [
			"armslegs",
			"l",
			"upperarm",
			"fat"
		],
		"data/targets/asym/asym-mouth-1-r.target": [
			"asym",
			"asym",
			"mouth",
			"1",
			"r"
		],
		"data/targets/macrodetails/height/male-baby-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-temple-2-l.target": [
			"asym",
			"asym",
			"temple",
			"2",
			"l"
		],
		"data/targets/eyes/l-eye-eyefold-angle-up.target": [
			"eyes",
			"l",
			"eye",
			"eyefold",
			"angle",
			"up"
		],
		"data/targets/torso/torso-muscle-dorsi-incr.target": [
			"torso",
			"torso",
			"muscle",
			"dorsi",
			"incr"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-eye-7-r.target": [
			"asym",
			"asym",
			"eye",
			"7",
			"r"
		],
		"data/targets/mouth/mouth-lowerlip-ext-up.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"ext",
			"up"
		],
		"data/targets/measure/measure-upperarm-decrease.target": [
			"measure",
			"measure",
			"upperarm",
			"decrease"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-push2-in.target": [
			"eyes",
			"l",
			"eye",
			"push2",
			"in"
		],
		"data/targets/expression/units/asian/mouth-corner-puller.target": [
			"expression",
			"units",
			"mouth",
			"corner",
			"puller"
		],
		"data/targets/armslegs/r-leg-genu-varun.target": [
			"armslegs",
			"r",
			"leg",
			"genu",
			"varun"
		],
		"data/targets/nose/nose-width2-min.target": [
			"nose",
			"nose",
			"width2",
			"min"
		],
		"data/targets/expression/units/african/eye-right-opened-up.target": [
			"expression",
			"units",
			"eye",
			"right",
			"opened",
			"up"
		],
		"data/targets/macrodetails/height/male-old-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/male-baby-maxmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/chin/chin-width-max.target": [
			"chin",
			"chin",
			"width",
			"max"
		],
		"data/targets/macrodetails/proportions/female-child-averagemuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/torso/torso-muscle-pectoral-decr.target": [
			"torso",
			"torso",
			"muscle",
			"pectoral",
			"decr"
		],
		"data/targets/macrodetails/height/male-baby-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/measure/measure-lowerlegheight-increase.target": [
			"measure",
			"measure",
			"lowerlegheight",
			"increase"
		],
		"data/targets/chin/chin-prominent-less.target": [
			"chin",
			"chin",
			"prominent",
			"less"
		],
		"data/targets/nose/nose-septumangle-incr.target": [
			"nose",
			"nose",
			"septumangle",
			"incr"
		],
		"data/targets/macrodetails/height/male-old-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/measure/measure-napetowaist-decrease.target": [
			"measure",
			"measure",
			"napetowaist",
			"decrease"
		],
		"data/targets/asym/asym-cheek-1-r.target": [
			"asym",
			"asym",
			"cheek",
			"1",
			"r"
		],
		"data/targets/nose/nose-scale-vert-incr.target": [
			"nose",
			"nose",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/breast/female-young-minmuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-minmuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-old-averagemuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/male-old-minmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/stomach/stomach-pregnant-incr.target": [
			"stomach",
			"stomach",
			"pregnant",
			"incr"
		],
		"data/targets/eyes/r-eye-corner2-up.target": [
			"eyes",
			"r",
			"eye",
			"corner2",
			"up"
		],
		"data/targets/breast/nipple-size-max.target": [
			"breast",
			"nipple",
			"size",
			"max"
		],
		"data/targets/armslegs/r-foot-trans-in.target": [
			"armslegs",
			"r",
			"foot",
			"trans",
			"in"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-child-averagemuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/torso/torso-scale-vert-decr.target": [
			"torso",
			"torso",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/eyes/r-eye-corner2-down.target": [
			"eyes",
			"r",
			"eye",
			"corner2",
			"down"
		],
		"data/targets/expression/units/asian/mouth-pursing.target": [
			"expression",
			"units",
			"mouth",
			"pursing"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/expression/units/african/eye-right-slit.target": [
			"expression",
			"units",
			"eye",
			"right",
			"slit"
		],
		"data/targets/head/head-scale-vert-more.target": [
			"head",
			"head",
			"scale",
			"vert",
			"more"
		],
		"data/targets/macrodetails/proportions/female-old-averagemuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-maxmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/eyebrows/eyebrows-trans-vert-less.target": [
			"eyebrows",
			"eyebrows",
			"trans",
			"vert",
			"less"
		],
		"data/targets/armslegs/l-upperleg-muscle-decr.target": [
			"armslegs",
			"l",
			"upperleg",
			"muscle",
			"decr"
		],
		"data/targets/expression/units/african/mouth-compression.target": [
			"expression",
			"units",
			"mouth",
			"compression"
		],
		"data/targets/eyes/r-eye-height1-min.target": [
			"eyes",
			"r",
			"eye",
			"height1",
			"min"
		],
		"data/targets/genitals/penis-testicles-max.target": [
			"genitals",
			"penis",
			"testicles",
			"max"
		],
		"data/targets/chin/chin-height-max.target": [
			"chin",
			"chin",
			"height",
			"max"
		],
		"data/targets/macrodetails/height/female-baby-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/male-young-maxmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/chin/chin-bones-in.target": [
			"chin",
			"chin",
			"bones",
			"in"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-child-maxmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/asym/asym-eye-6-r.target": [
			"asym",
			"asym",
			"eye",
			"6",
			"r"
		],
		"data/targets/macrodetails/proportions/male-young-averagemuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/male-young-maxmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/female-old-maxmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/l-upperleg-scale-depth-incr.target": [
			"armslegs",
			"l",
			"upperleg",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/expression/units/african/eye-left-slit.target": [
			"expression",
			"units",
			"eye",
			"left",
			"slit"
		],
		"data/targets/ears/r-ear-size-big.target": [
			"ears",
			"r",
			"ear",
			"size",
			"big"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-old-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-hand-scale-incr.target": [
			"armslegs",
			"l",
			"hand",
			"scale",
			"incr"
		],
		"data/targets/macrodetails/universal-female-young-minmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-old-minmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-young-maxmuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/caucasian/mouth-depression.target": [
			"expression",
			"units",
			"mouth",
			"depression"
		],
		"data/targets/expression/units/african/nose-depression.target": [
			"expression",
			"units",
			"nose",
			"depression"
		],
		"data/targets/macrodetails/caucasian-female-child.target": [
			"macrodetails"
		],
		"data/targets/macrodetails/height/female-baby-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-child-maxmuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-child-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/head/head-age-more.target": [
			"head",
			"head",
			"age",
			"more"
		],
		"data/targets/nose/nose-hump-lesshump.target": [
			"nose",
			"nose",
			"hump",
			"lesshump"
		],
		"data/targets/mouth/mouth-philtrum-volume-increase.target": [
			"mouth",
			"mouth",
			"philtrum",
			"volume",
			"increase"
		],
		"data/targets/eyes/r-eye-push2-out.target": [
			"eyes",
			"r",
			"eye",
			"push2",
			"out"
		],
		"data/targets/expression/units/asian/eye-right-slit.target": [
			"expression",
			"units",
			"eye",
			"right",
			"slit"
		],
		"data/targets/armslegs/l-lowerarm-muscle-decr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"muscle",
			"decr"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-epicanthus-in.target": [
			"eyes",
			"r",
			"eye",
			"epicanthus",
			"in"
		],
		"data/targets/genitals/penis-circ-min.target": [
			"genitals",
			"penis",
			"circ",
			"min"
		],
		"data/targets/macrodetails/height/male-child-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-female-old-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-minmuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-male-young-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/nose/nose-width2-max.target": [
			"nose",
			"nose",
			"width2",
			"max"
		],
		"data/targets/macrodetails/height/female-child-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-hand-fingers-length-decr.target": [
			"armslegs",
			"r",
			"hand",
			"fingers",
			"length",
			"decr"
		],
		"data/targets/macrodetails/universal-female-child-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/armslegs/r-lowerleg-scale-depth-decr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/armslegs/l-lowerarm-scale-horiz-decr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/armslegs/l-upperleg-scale-vert-incr.target": [
			"armslegs",
			"l",
			"upperleg",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/cheek/l-cheek-inner-deflate.target": [
			"cheek",
			"l",
			"cheek",
			"inner",
			"deflate"
		],
		"data/targets/neck/neck-back-scale-depth-more.target": [
			"neck",
			"neck",
			"back",
			"scale",
			"depth",
			"more"
		],
		"data/targets/pelvis/bulge-incr.target": [
			"pelvis",
			"bulge",
			"incr"
		],
		"data/targets/expression/units/african/mouth-depression.target": [
			"expression",
			"units",
			"mouth",
			"depression"
		],
		"data/targets/mouth/mouth-upperlip-height-max.target": [
			"mouth",
			"mouth",
			"upperlip",
			"height",
			"max"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-male-old-maxmuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/mouth/mouth-cupidsbow-width-min.target": [
			"mouth",
			"mouth",
			"cupidsbow",
			"width",
			"min"
		],
		"data/targets/macrodetails/height/male-old-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/asian/nose-left-dilatation.target": [
			"expression",
			"units",
			"nose",
			"left",
			"dilatation"
		],
		"data/targets/breast/female-old-minmuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/l-leg-genu-varun.target": [
			"armslegs",
			"l",
			"leg",
			"genu",
			"varun"
		],
		"data/targets/measure/measure-ankle-decrease.target": [
			"measure",
			"measure",
			"ankle",
			"decrease"
		],
		"data/targets/mouth/mouth-angles-up.target": [
			"mouth",
			"mouth",
			"angles",
			"up"
		],
		"data/targets/breast/female-old-maxmuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/nose/nose-curve-convex.target": [
			"nose",
			"nose",
			"curve",
			"convex"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-young-maxmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/neck/neck-double-less.target": [
			"neck",
			"neck",
			"double",
			"less"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-minmuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-old-averagemuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/universal-male-child-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/female-child-minmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/female-old-maxmuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-child-minmuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-upperleg-skinny.target": [
			"armslegs",
			"r",
			"upperleg",
			"skinny"
		],
		"data/targets/chin/chin-cleft-in.target": [
			"chin",
			"chin",
			"cleft",
			"in"
		],
		"data/targets/expression/units/caucasian/eye-left-slit.target": [
			"expression",
			"units",
			"eye",
			"left",
			"slit"
		],
		"data/targets/macrodetails/proportions/male-old-maxmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-leg-genu-valgus.target": [
			"armslegs",
			"r",
			"leg",
			"genu",
			"valgus"
		],
		"data/targets/breast/female-child-averagemuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-eyefold-convex.target": [
			"eyes",
			"r",
			"eye",
			"eyefold",
			"convex"
		],
		"data/targets/macrodetails/universal-female-baby-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/ears/r-ear-shape1-triangle.target": [
			"ears",
			"r",
			"ear",
			"shape1",
			"triangle"
		],
		"data/targets/armslegs/l-lowerleg-scale-horiz-decr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/ears/l-ear-shape2-square.target": [
			"ears",
			"l",
			"ear",
			"shape2",
			"square"
		],
		"data/targets/macrodetails/height/male-child-minmuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-averagemuscle-minweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/genitals/penis-length-min.target": [
			"genitals",
			"penis",
			"length",
			"min"
		],
		"data/targets/cheek/r-cheek-trans-vert-down.target": [
			"cheek",
			"r",
			"cheek",
			"trans",
			"vert",
			"down"
		],
		"data/targets/macrodetails/height/female-baby-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-minmuscle-maxweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/caucasian/mouth-elevation.target": [
			"expression",
			"units",
			"mouth",
			"elevation"
		],
		"data/targets/breast/female-young-minmuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-nose-2-l.target": [
			"asym",
			"asym",
			"nose",
			"2",
			"l"
		],
		"data/targets/breast/female-old-maxmuscle-averageweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-young-minmuscle-minweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/armslegs/r-foot-scale-decr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"decr"
		],
		"data/targets/head/head-angle-in.target": [
			"head",
			"head",
			"angle",
			"in"
		],
		"data/targets/chin/chin-prognathism-less.target": [
			"chin",
			"chin",
			"prognathism",
			"less"
		],
		"data/targets/macrodetails/proportions/male-child-minmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-upperarm-muscle-incr.target": [
			"armslegs",
			"r",
			"upperarm",
			"muscle",
			"incr"
		],
		"data/targets/armslegs/l-lowerarm-muscle-incr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"muscle",
			"incr"
		],
		"data/targets/macrodetails/height/female-old-maxmuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/nose/nose-trans-depth-backward.target": [
			"nose",
			"nose",
			"trans",
			"depth",
			"backward"
		],
		"data/targets/asym/asym-top-1-r.target": [
			"asym",
			"asym",
			"top",
			"1",
			"r"
		],
		"data/targets/mouth/mouth-trans-down.target": [
			"mouth",
			"mouth",
			"trans",
			"down"
		],
		"data/targets/macrodetails/height/female-baby-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/expression/units/african/eyebrows-right-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"up"
		],
		"data/targets/macrodetails/universal-female-young-averagemuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-child-averagemuscle-averageweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-child-averagemuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-bag-in.target": [
			"eyes",
			"r",
			"eye",
			"bag",
			"in"
		],
		"data/targets/breast/female-young-maxmuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/r-lowerleg-scale-vert-incr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/armslegs/l-lowerleg-fat.target": [
			"armslegs",
			"l",
			"lowerleg",
			"fat"
		],
		"data/targets/measure/measure-neckcirc-decrease.target": [
			"measure",
			"measure",
			"neckcirc",
			"decrease"
		],
		"data/targets/expression/units/caucasian/mouth-open.target": [
			"expression",
			"units",
			"mouth",
			"open"
		],
		"data/targets/macrodetails/height/female-old-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-maxmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/mouth/mouth-lowerlip-volume-deflate.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"volume",
			"deflate"
		],
		"data/targets/armslegs/l-lowerleg-muscle-decr.target": [
			"armslegs",
			"l",
			"lowerleg",
			"muscle",
			"decr"
		],
		"data/targets/macrodetails/height/male-child-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/female-old-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/neck/neck-scale-depth-less.target": [
			"neck",
			"neck",
			"scale",
			"depth",
			"less"
		],
		"data/targets/expression/units/asian/mouth-retraction.target": [
			"expression",
			"units",
			"mouth",
			"retraction"
		],
		"data/targets/macrodetails/caucasian-female-young.target": [
			"macrodetails"
		],
		"data/targets/ears/r-ear-wing-in.target": [
			"ears",
			"r",
			"ear",
			"wing",
			"in"
		],
		"data/targets/expression/units/asian/eye-left-opened-up.target": [
			"expression",
			"units",
			"eye",
			"left",
			"opened",
			"up"
		],
		"data/targets/asym/asym-jaw-2-r.target": [
			"asym",
			"asym",
			"jaw",
			"2",
			"r"
		],
		"data/targets/macrodetails/proportions/female-young-minmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/proportions/male-child-averagemuscle-averageweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/caucasian/eyebrows-right-inner-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"inner",
			"up"
		],
		"data/targets/macrodetails/height/male-child-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-temple-1-l.target": [
			"asym",
			"asym",
			"temple",
			"1",
			"l"
		],
		"data/targets/genitals/penis-circ-max.target": [
			"genitals",
			"penis",
			"circ",
			"max"
		],
		"data/targets/hip/hip-trans-out.target": [
			"hip",
			"hip",
			"trans",
			"out"
		],
		"data/targets/armslegs/r-hand-fingers-distance-incr.target": [
			"armslegs",
			"r",
			"hand",
			"fingers",
			"distance",
			"incr"
		],
		"data/targets/breast/female-old-averagemuscle-averageweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-old-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/nose/nose-height-max.target": [
			"nose",
			"nose",
			"height",
			"max"
		],
		"data/targets/macrodetails/height/male-baby-averagemuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/universal-male-child-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/female-old-minmuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/macrodetails/height/female-young-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-foot-scale-incr.target": [
			"armslegs",
			"l",
			"foot",
			"scale",
			"incr"
		],
		"data/targets/eyes/l-eye-bag-min.target": [
			"eyes",
			"l",
			"eye",
			"bag",
			"min"
		],
		"data/targets/forehead/forehead-nubian-less.target": [
			"forehead",
			"forehead",
			"nubian",
			"less"
		],
		"data/targets/breast/female-young-maxmuscle-maxweight-averagecup-minfirmness.target": [
			"breast"
		],
		"data/targets/stomach/stomach-tone-decr.target": [
			"stomach",
			"stomach",
			"tone",
			"decr"
		],
		"data/targets/armslegs/r-lowerarm-scale-depth-decr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"scale",
			"depth",
			"decr"
		],
		"data/targets/macrodetails/height/female-old-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-maxmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/ears/r-ear-flap-out.target": [
			"ears",
			"r",
			"ear",
			"flap",
			"out"
		],
		"data/targets/macrodetails/proportions/male-child-minmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/cheek/r-cheek-inner-inflate.target": [
			"cheek",
			"r",
			"cheek",
			"inner",
			"inflate"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-eye-6-l.target": [
			"asym",
			"asym",
			"eye",
			"6",
			"l"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/male-child-averagemuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/ears/r-ear-trans-vert-down.target": [
			"ears",
			"r",
			"ear",
			"trans",
			"vert",
			"down"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/eyes/l-eye-height2-max.target": [
			"eyes",
			"l",
			"eye",
			"height2",
			"max"
		],
		"data/targets/macrodetails/proportions/male-old-maxmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/measure/measure-calf-decrease.target": [
			"measure",
			"measure",
			"calf",
			"decrease"
		],
		"data/targets/ears/l-ear-flap-in.target": [
			"ears",
			"l",
			"ear",
			"flap",
			"in"
		],
		"data/targets/breast/female-child-minmuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/ears/l-ear-wing-in.target": [
			"ears",
			"l",
			"ear",
			"wing",
			"in"
		],
		"data/targets/armslegs/r-lowerleg-scale-vert-decr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/ears/r-ear-lobe-min.target": [
			"ears",
			"r",
			"ear",
			"lobe",
			"min"
		],
		"data/targets/macrodetails/height/male-baby-maxmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-nose-1-r.target": [
			"asym",
			"asym",
			"nose",
			"1",
			"r"
		],
		"data/targets/mouth/mouth-lowerlip-height-min.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"height",
			"min"
		],
		"data/targets/macrodetails/height/male-old-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/hip/hip-trans-down.target": [
			"hip",
			"hip",
			"trans",
			"down"
		],
		"data/targets/buttocks/buttocks-volume-incr.target": [
			"buttocks",
			"buttocks",
			"volume",
			"incr"
		],
		"data/targets/breast/female-young-averagemuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/eyes/r-eye-corner1-up.target": [
			"eyes",
			"r",
			"eye",
			"corner1",
			"up"
		],
		"data/targets/neck/neck-back-scale-depth-less.target": [
			"neck",
			"neck",
			"back",
			"scale",
			"depth",
			"less"
		],
		"data/targets/armslegs/r-foot-trans-backward.target": [
			"armslegs",
			"r",
			"foot",
			"trans",
			"backward"
		],
		"data/targets/breast/breast-trans-vert-down.target": [
			"breast",
			"breast",
			"trans",
			"vert",
			"down"
		],
		"data/targets/breast/female-child-maxmuscle-minweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/mouth/mouth-lowerlip-height-max.target": [
			"mouth",
			"mouth",
			"lowerlip",
			"height",
			"max"
		],
		"data/targets/ears/l-ear-shape1-triangle.target": [
			"ears",
			"l",
			"ear",
			"shape1",
			"triangle"
		],
		"data/targets/expression/units/caucasian/eyebrows-right-up.target": [
			"expression",
			"units",
			"eyebrows",
			"right",
			"up"
		],
		"data/targets/asym/asym-ear-1-r.target": [
			"asym",
			"asym",
			"ear",
			"1",
			"r"
		],
		"data/targets/neck/neck-scale-depth-more.target": [
			"neck",
			"neck",
			"scale",
			"depth",
			"more"
		],
		"data/targets/mouth/mouth-trans-forward.target": [
			"mouth",
			"mouth",
			"trans",
			"forward"
		],
		"data/targets/stomach/stomach-navel-down.target": [
			"stomach",
			"stomach",
			"navel",
			"down"
		],
		"data/targets/asym/asym-ear-2-r.target": [
			"asym",
			"asym",
			"ear",
			"2",
			"r"
		],
		"data/targets/expression/units/caucasian/mouth-eversion.target": [
			"expression",
			"units",
			"mouth",
			"eversion"
		],
		"data/targets/expression/units/asian/neck-platysma.target": [
			"expression",
			"units",
			"neck",
			"platysma"
		],
		"data/targets/macrodetails/proportions/female-old-averagemuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/nose/nose-flaring-incr.target": [
			"nose",
			"nose",
			"flaring",
			"incr"
		],
		"data/targets/armslegs/r-lowerarm-muscle-decr.target": [
			"armslegs",
			"r",
			"lowerarm",
			"muscle",
			"decr"
		],
		"data/targets/eyes/l-eye-move-down.target": [
			"eyes",
			"l",
			"eye",
			"move",
			"down"
		],
		"data/targets/armslegs/r-lowerleg-scale-depth-incr.target": [
			"armslegs",
			"r",
			"lowerleg",
			"scale",
			"depth",
			"incr"
		],
		"data/targets/mouth/mouth-upperlip-ext-up.target": [
			"mouth",
			"mouth",
			"upperlip",
			"ext",
			"up"
		],
		"data/targets/asym/asym-brown-2-l.target": [
			"asym",
			"asym",
			"brown",
			"2",
			"l"
		],
		"data/targets/expression/units/african/mouth-depression-retraction.target": [
			"expression",
			"units",
			"mouth",
			"depression",
			"retraction"
		],
		"data/targets/armslegs/l-foot-trans-up.target": [
			"armslegs",
			"l",
			"foot",
			"trans",
			"up"
		],
		"data/targets/macrodetails/proportions/male-young-averagemuscle-maxweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-old-averagemuscle-maxweight-maxcup-averagefirmness.target": [
			"breast"
		],
		"data/targets/asym/asym-eye-3-r.target": [
			"asym",
			"asym",
			"eye",
			"3",
			"r"
		],
		"data/targets/macrodetails/proportions/female-child-minmuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-upperleg-muscle-decr.target": [
			"armslegs",
			"r",
			"upperleg",
			"muscle",
			"decr"
		],
		"data/targets/measure/measure-frontchest-decrease.target": [
			"measure",
			"measure",
			"frontchest",
			"decrease"
		],
		"data/targets/eyes/l-eye-size-small.target": [
			"eyes",
			"l",
			"eye",
			"size",
			"small"
		],
		"data/targets/expression/units/asian/nose-right-elevation.target": [
			"expression",
			"units",
			"nose",
			"right",
			"elevation"
		],
		"data/targets/macrodetails/proportions/male-young-maxmuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/expression/units/asian/mouth-compression.target": [
			"expression",
			"units",
			"mouth",
			"compression"
		],
		"data/targets/macrodetails/height/male-baby-averagemuscle-averageweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/chin/chin-width-min.target": [
			"chin",
			"chin",
			"width",
			"min"
		],
		"data/targets/macrodetails/proportions/female-young-averagemuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/eyes/l-eye-eyefold-angle-down.target": [
			"eyes",
			"l",
			"eye",
			"eyefold",
			"angle",
			"down"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-mincup-minfirmness.target": [
			"breast"
		],
		"data/targets/expression/units/asian/eye-right-opened-up.target": [
			"expression",
			"units",
			"eye",
			"right",
			"opened",
			"up"
		],
		"data/targets/macrodetails/height/female-child-minmuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-lowerarm-scale-vert-incr.target": [
			"armslegs",
			"l",
			"lowerarm",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/stomach/stomach-tone-incr.target": [
			"stomach",
			"stomach",
			"tone",
			"incr"
		],
		"data/targets/macrodetails/universal-male-child-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/height/female-young-minmuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/stomach/stomach-navel-in.target": [
			"stomach",
			"stomach",
			"navel",
			"in"
		],
		"data/targets/eyebrows/eyebrows-angle-up.target": [
			"eyebrows",
			"eyebrows",
			"angle",
			"up"
		],
		"data/targets/macrodetails/height/male-child-minmuscle-minweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/height/female-young-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/breast/female-old-averagemuscle-minweight-mincup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/proportions/female-young-maxmuscle-maxweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/armslegs/r-upperleg-scale-horiz-incr.target": [
			"armslegs",
			"r",
			"upperleg",
			"scale",
			"horiz",
			"incr"
		],
		"data/targets/asym/asym-cheek-2-r.target": [
			"asym",
			"asym",
			"cheek",
			"2",
			"r"
		],
		"data/targets/ears/r-ear-lobe-max.target": [
			"ears",
			"r",
			"ear",
			"lobe",
			"max"
		],
		"data/targets/eyes/l-eye-eyefold-down.target": [
			"eyes",
			"l",
			"eye",
			"eyefold",
			"down"
		],
		"data/targets/expression/units/african/mouth-parling.target": [
			"expression",
			"units",
			"mouth",
			"parling"
		],
		"data/targets/macrodetails/height/female-young-averagemuscle-maxweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/female-young-averagemuscle-minweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/neck/neck-scale-horiz-more.target": [
			"neck",
			"neck",
			"scale",
			"horiz",
			"more"
		],
		"data/targets/macrodetails/height/female-old-minmuscle-minweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-upperleg-scale-vert-decr.target": [
			"armslegs",
			"l",
			"upperleg",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/ears/r-ear-rot-forward.target": [
			"ears",
			"r",
			"ear",
			"rot",
			"forward"
		],
		"data/targets/expression/units/asian/mouth-open.target": [
			"expression",
			"units",
			"mouth",
			"open"
		],
		"data/targets/macrodetails/height/male-old-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/asym/asym-ear-3-l.target": [
			"asym",
			"asym",
			"ear",
			"3",
			"l"
		],
		"data/targets/armslegs/r-lowerarm-fat.target": [
			"armslegs",
			"r",
			"lowerarm",
			"fat"
		],
		"data/targets/ears/l-ear-trans-vert-up.target": [
			"ears",
			"l",
			"ear",
			"trans",
			"vert",
			"up"
		],
		"data/targets/macrodetails/universal-male-young-maxmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/breast/female-young-averagemuscle-averageweight-maxcup-minfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-old-maxmuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/macrodetails/proportions/male-child-minmuscle-minweight-uncommonproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/mouth/mouth-upperlip-ext-down.target": [
			"mouth",
			"mouth",
			"upperlip",
			"ext",
			"down"
		],
		"data/targets/macrodetails/universal-male-young-minmuscle-minweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/measure/measure-thighcirc-increase.target": [
			"measure",
			"measure",
			"thighcirc",
			"increase"
		],
		"data/targets/measure/measure-upperarm-increase.target": [
			"measure",
			"measure",
			"upperarm",
			"increase"
		],
		"data/targets/torso/torso-scale-horiz-decr.target": [
			"torso",
			"torso",
			"scale",
			"horiz",
			"decr"
		],
		"data/targets/torso/torso-trans-vert-up.target": [
			"torso",
			"torso",
			"trans",
			"vert",
			"up"
		],
		"data/targets/armslegs/l-hand-trans-in.target": [
			"armslegs",
			"l",
			"hand",
			"trans",
			"in"
		],
		"data/targets/breast/female-child-maxmuscle-maxweight-mincup-averagefirmness.target": [
			"breast"
		],
		"data/targets/breast/female-old-maxmuscle-maxweight-averagecup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/height/female-baby-averagemuscle-averageweight-minheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/macrodetails/proportions/male-young-averagemuscle-averageweight-idealproportions.target": [
			"macrodetails",
			"proportions"
		],
		"data/targets/breast/female-old-minmuscle-minweight-maxcup-maxfirmness.target": [
			"breast"
		],
		"data/targets/macrodetails/universal-female-old-averagemuscle-maxweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/armslegs/l-upperarm-scale-vert-incr.target": [
			"armslegs",
			"l",
			"upperarm",
			"scale",
			"vert",
			"incr"
		],
		"data/targets/macrodetails/height/male-baby-averagemuscle-maxweight-maxheight.target": [
			"macrodetails",
			"height"
		],
		"data/targets/armslegs/l-foot-trans-down.target": [
			"armslegs",
			"l",
			"foot",
			"trans",
			"down"
		],
		"data/targets/expression/units/caucasian/eyebrows-left-extern-up.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"extern",
			"up"
		],
		"data/targets/armslegs/r-lowerleg-skinny.target": [
			"armslegs",
			"r",
			"lowerleg",
			"skinny"
		],
		"data/targets/macrodetails/universal-female-young-averagemuscle-averageweight.target": [
			"macrodetails",
			"universal"
		],
		"data/targets/forehead/forehead-temple-out.target": [
			"forehead",
			"forehead",
			"temple",
			"out"
		],
		"data/targets/armslegs/r-foot-scale-vert-decr.target": [
			"armslegs",
			"r",
			"foot",
			"scale",
			"vert",
			"decr"
		],
		"data/targets/expression/units/asian/eyebrows-left-down.target": [
			"expression",
			"units",
			"eyebrows",
			"left",
			"down"
		],
		"data/targets/eyes/l-eye-height3-max.target": [
			"eyes",
			"l",
			"eye",
			"height3",
			"max"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/makehuman-data/src/json/targets/target-list.json
// module id = 151
// module chunks = 0